webpackJsonp([2],{

/***/ "+/J2":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds setted
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds) {
  var date = parse(dirtyDate)
  var milliseconds = Number(dirtyMilliseconds)
  date.setMilliseconds(milliseconds)
  return date
}

module.exports = setMilliseconds


/***/ }),

/***/ "+sSA":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(999)
  return date
}

module.exports = endOfSecond


/***/ }),

/***/ "/dIK":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),

/***/ "024F":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate) {
  var date = parse(dirtyDate)
  var milliseconds = date.getMilliseconds()
  return milliseconds
}

module.exports = getMilliseconds


/***/ }),

/***/ "0LAu":
/***/ (function(module, exports, __webpack_require__) {

var endOfDay = __webpack_require__("MIQa")

/**
 * @category Day Helpers
 * @summary Return the end of today.
 *
 * @description
 * Return the end of today.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday () {
  return endOfDay(new Date())
}

module.exports = endOfToday


/***/ }),

/***/ "0UyA":
/***/ (function(module, exports, __webpack_require__) {

var addYears = __webpack_require__("4Z4o")

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addYears(dirtyDate, -amount)
}

module.exports = subYears


/***/ }),

/***/ "0YGC":
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of yesterday.
 *
 * @description
 * Return the end of yesterday.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYesterday


/***/ }),

/***/ "0aH9":
/***/ (function(module, exports, __webpack_require__) {

var startOfISOWeek = __webpack_require__("3znZ")

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarISOWeeks


/***/ }),

/***/ "0oN5":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("WNGz")

/**
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 *
 * @description
 * Is the given date tomorrow?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow (dirtyDate) {
  var tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
}

module.exports = isTomorrow


/***/ }),

/***/ "11Bn":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var latestTimestamp = Math.max.apply(null, dates)
  return new Date(latestTimestamp)
}

module.exports = max


/***/ }),

/***/ "1gtq":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("WNGz")

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
}

module.exports = isYesterday


/***/ }),

/***/ "1rLR":
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__("3EIC")

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var months = amount * 3
  return addMonths(dirtyDate, months)
}

module.exports = addQuarters


/***/ }),

/***/ "1udo":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("WNGz")

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return startOfDay(new Date())
}

module.exports = startOfToday


/***/ }),

/***/ "25hp":
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__("G7No")

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),

/***/ "2lB6":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Range Helpers
 * @summary Is the given date range overlapping with another date range?
 *
 * @description
 * Is the given date range overlapping with another date range?
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Boolean} whether the date ranges are overlapping
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> false
 */
function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
}

module.exports = areRangesOverlapping


/***/ }),

/***/ "3EIC":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var getDaysInMonth = __webpack_require__("Mdww")

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),

/***/ "3g9B":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),

/***/ "3nPg":
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__("G7No")

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInMinutes


/***/ }),

/***/ "4LxA":
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__("iRXW")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}

module.exports = isSameISOYear


/***/ }),

/***/ "4OFc":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day === 0 || day === 6
}

module.exports = isWeekend


/***/ }),

/***/ "4Z4o":
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__("3EIC")

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),

/***/ "4zIR":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse(dirtyDate).getTime()
  var startTime = parse(dirtyStartDate).getTime()
  var endTime = parse(dirtyEndDate).getTime()

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

module.exports = isWithinRange


/***/ }),

/***/ "5nQB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5qwL":
/***/ (function(module, exports, __webpack_require__) {

var startOfSecond = __webpack_require__("VaeB")

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}

module.exports = isSameSecond


/***/ }),

/***/ "5zIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/web/component/web/swiper/swiper.vue


/* harmony default export */ var swiper = ({
    data: function data() {
        return {
            show: 0,
            swiperOpacity: 0
        };
    },

    watch: {
        swiperOpacity: function swiperOpacity(val) {
            if (val >= 5) {
                this.show = this.show + 1;
            }
        },
        show: function show(val) {
            if (this.list.length > 1) {
                this.swiperOpacity = 0;
            } else {
                this.swiperOpacity = 1;
            }
            if (val > this.list.length - 1) {
                this.show = 0;
            }
            if (val < 0) {
                this.show = this.list.length - 1;
            }
        }
    },
    mounted: function mounted() {
        var self = this;
        function changeSwiperOpacity() {
            if (self.list.length > 1) {
                self.swiperOpacity = ((self.swiperOpacity * 10000 + 50) / 10000).toFixed(6);
            } else {
                self.swiperOpacity = 1;
            }
        }
        setInterval(changeSwiperOpacity);
    },

    props: ['list', 'type'],
    methods: {
        prev: function prev() {
            this.show -= 1;
        },
        next: function next() {
            this.show += 1;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b8e5b1b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/swiper/swiper.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.type == 1
      ? _c("div", { staticClass: "slide ad1" }, [
          _c("div", { staticClass: "bd" }, [
            _c(
              "ul",
              _vm._l(_vm.list, function(item, index) {
                return _c(
                  "li",
                  {
                    style: {
                      display: _vm.show == index ? "block" : "none",
                      opacity: _vm.show == index ? _vm.swiperOpacity : 0
                    }
                  },
                  [
                    _c("a", { attrs: { href: item.url, target: "_blank" } }, [
                      _c("img", { attrs: { src: item.images[0].url } })
                    ])
                  ]
                )
              })
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "hd" }, [
            _c(
              "ul",
              _vm._l(_vm.list, function(item, index) {
                return _c(
                  "li",
                  { staticClass: "elip", class: { on: _vm.show == index } },
                  [_vm._v(_vm._s(item.title))]
                )
              })
            )
          ]),
          _vm._v(" "),
          _c("a", {
            staticClass: "prev",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                _vm.prev()
              }
            }
          }),
          _vm._v(" "),
          _c("a", {
            staticClass: "next",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                _vm.next()
              }
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type == 2
      ? _c("div", { staticClass: "slide ad1" }, [
          _c("div", { staticClass: "bd" }, [
            _c(
              "ul",
              _vm._l(_vm.list, function(item, index) {
                return _c(
                  "li",
                  {
                    style: {
                      display: _vm.show == index ? "block" : "none",
                      opacity: _vm.show == index ? _vm.swiperOpacity : 0
                    }
                  },
                  [_c("img", { attrs: { src: item.path } })]
                )
              })
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "hd" }, [
            _c(
              "ul",
              _vm._l(_vm.list, function(item, index) {
                return _c("li", { class: { on: _vm.show == index } }, [
                  _vm._v(_vm._s(item.miaoshu))
                ])
              })
            )
          ]),
          _vm._v(" "),
          _c("a", {
            staticClass: "prev",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                _vm.prev()
              }
            }
          }),
          _vm._v(" "),
          _c("a", {
            staticClass: "next",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                _vm.next()
              }
            }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var swiper_swiper = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-5b8e5b1b", esExports)
  }
}
// CONCATENATED MODULE: ./app/web/component/web/swiper/swiper.vue
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  swiper,
  swiper_swiper,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "app/web/component/web/swiper/swiper.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5b8e5b1b", Component.options)
  } else {
    hotAPI.reload("data-v-5b8e5b1b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var web_swiper_swiper = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6CZb":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture (dirtyDate) {
  return parse(dirtyDate).getTime() > new Date().getTime()
}

module.exports = isFuture


/***/ }),

/***/ "6SO/":
/***/ (function(module, exports, __webpack_require__) {

var differenceInDays = __webpack_require__("gAt4")

/**
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInWeeks


/***/ }),

/***/ "6Zhv":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount) {
  var timestamp = parse(dirtyDate).getTime()
  var amount = Number(dirtyAmount)
  return new Date(timestamp + amount)
}

module.exports = addMilliseconds


/***/ }),

/***/ "6axH":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate) {
  return parse(dirtyDate).getDay() === 6
}

module.exports = isSaturday


/***/ }),

/***/ "6udH":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate) {
  return parse(dirtyDate).getDate() === 1
}

module.exports = isFirstDayOfMonth


/***/ }),

/***/ "7EGB":
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__("Jvcu")

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var days = amount * 7
  return addDays(dirtyDate, days)
}

module.exports = addWeeks


/***/ }),

/***/ "7Swd":
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__("3EIC")

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),

/***/ "7Xwz":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),

/***/ "7yyf":
/***/ (function(module, exports, __webpack_require__) {

var startOfQuarter = __webpack_require__("rBmI")

/**
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}

module.exports = isSameQuarter


/***/ }),

/***/ "8Gpr":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate) {
  var date = parse(dirtyDate)
  var hours = date.getHours()
  return hours
}

module.exports = getHours


/***/ }),

/***/ "8KV+":
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__("u/4p")

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

module.exports = isSameWeek


/***/ }),

/***/ "8QR2":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * @category Range Helpers
 * @summary Get the number of days that overlap in two date ranges
 *
 * @description
 * Get the number of days that overlap in two date ranges
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Number} the number of days that overlap in two date ranges
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges adds 1 for each started overlapping day:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping date ranges returns 0:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> 0
 */
function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = comparedStartTime < initialStartTime
    ? initialStartTime
    : comparedStartTime

  var overlapEndDate = comparedEndTime > initialEndTime
    ? initialEndTime
    : comparedEndTime

  var differenceInMs = overlapEndDate - overlapStartDate

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
}

module.exports = getOverlappingDaysInRanges


/***/ }),

/***/ "9Jn5":
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__("zZbG")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
}

module.exports = differenceInCalendarISOYears


/***/ }),

/***/ "9r5b":
/***/ (function(module, exports, __webpack_require__) {

var addSeconds = __webpack_require__("nfOx")

/**
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @returns {Date} the new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addSeconds(dirtyDate, -amount)
}

module.exports = subSeconds


/***/ }),

/***/ "A2zO":
/***/ (function(module, exports, __webpack_require__) {

var isSameISOWeek = __webpack_require__("Be26")

/**
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek (dirtyDate) {
  return isSameISOWeek(new Date(), dirtyDate)
}

module.exports = isThisISOWeek


/***/ }),

/***/ "AZvW":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()

  if (day === 0) {
    day = 7
  }

  return day
}

module.exports = getISODay


/***/ }),

/***/ "Akl5":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfMonth


/***/ }),

/***/ "Bb5e":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  return dateLeft.getFullYear() - dateRight.getFullYear()
}

module.exports = differenceInCalendarYears


/***/ }),

/***/ "Be26":
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__("8KV+")

/**
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
}

module.exports = isSameISOWeek


/***/ }),

/***/ "CVNg":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year setted
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear) {
  var date = parse(dirtyDate)
  var dayOfYear = Number(dirtyDayOfYear)
  date.setMonth(0)
  date.setDate(dayOfYear)
  return date
}

module.exports = setDayOfYear


/***/ }),

/***/ "Epw6":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYear


/***/ }),

/***/ "G7No":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),

/***/ "GI7G":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var differenceInCalendarMonths = __webpack_require__("orNa")
var compareAsc = __webpack_require__("NKE6")

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),

/***/ "GKSN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./app/web/framework/vue/entry/client.js + 2 modules
var client = __webpack_require__("y1Jk");

// EXTERNAL MODULE: ./app/web/component/web/news-layout/index.js + 9 modules
var news_layout = __webpack_require__("bqqu");

// EXTERNAL MODULE: ./app/web/component/web/news-aside/index.vue + 2 modules
var news_aside = __webpack_require__("gIln");

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.common.js
var vue_common = __webpack_require__("I3G/");
var vue_common_default = /*#__PURE__*/__webpack_require__.n(vue_common);

// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.js
var vue_lazyload = __webpack_require__("cTzj");
var vue_lazyload_default = /*#__PURE__*/__webpack_require__.n(vue_lazyload);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/web/component/web/news-aside/ad-aside.vue




vue_common_default.a.use(vue_lazyload_default.a);
/* harmony default export */ var ad_aside = ({
    props: ['list', 'clientId'],
    data: function data() {
        return {
            newsList: []
        };
    },

    computed: {
        lazyLoading: function lazyLoading() {
            if (this.clientId) {
                return '/public/w/img/' + this.clientId + '/loading_news.png';
            } else {
                return '/public/w/default/loading_news.png';
            }
        }
    },
    components: {},
    mounted: function mounted() {

        if (this.clientId == 410900) {
            this.newsList = this.list.reverse();
        } else {
            this.newsList = this.list;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06aea66b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-aside/ad-aside.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "aside-2 ad" }, [
    _c("div", { staticClass: "bd" }, [
      _c(
        "ul",
        _vm._l(_vm.newsList, function(item, index) {
          return _c(
            "li",
            {
              staticClass: "aside-2 ad",
              staticStyle: { display: "list-item" }
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: item.items[0].url,
                    target: "_blank",
                    alt: "..."
                  }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy",
                        value: {
                          loading: _vm.lazyLoading,
                          error: _vm.lazyLoading,
                          src: item.items[0]["images"][0]["url"]
                        },
                        expression:
                          "{\n                        loading: lazyLoading,\n                        error: lazyLoading,\n                        src: item.items[0]['images'][0]['url']\n                      }"
                      }
                    ]
                  })
                ]
              )
            ]
          )
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var news_aside_ad_aside = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-06aea66b", esExports)
  }
}
// CONCATENATED MODULE: ./app/web/component/web/news-aside/ad-aside.vue
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ad_aside,
  news_aside_ad_aside,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "app/web/component/web/news-aside/ad-aside.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-06aea66b", Component.options)
  } else {
    hotAPI.reload("data-v-06aea66b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var web_news_aside_ad_aside = (Component.exports);

// EXTERNAL MODULE: ./app/web/asset/js/utils/friendlyTime.js + 1 modules
var friendlyTime = __webpack_require__("p4GF");

// EXTERNAL MODULE: ./app/web/asset/news-pc/js/axios.js
var axios = __webpack_require__("Pbpa");

// EXTERNAL MODULE: ./app/web/asset/news-pc/js/api.js
var api = __webpack_require__("hkaH");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/web/component/web/news-aside/ranking-aside.vue







vue_common_default.a.use(vue_lazyload_default.a, {
    error: '/public/w/img/wap/loading.png',
    loading: '/public/w/img/wap/loading.png'
});
/* harmony default export */ var ranking_aside = ({
    props: ['title', 'list'],
    data: function data() {
        return {
            topNumber: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'],
            friendlyTime: friendlyTime["a" /* default */]
        };
    },
    mounted: function mounted() {
        this.getRewen('day');
    },

    methods: {
        getRewen: function getRewen(type) {
            var _this = this;

            axios["a" /* default */].get(api["a" /* default */].rewen + '?pagesize=10&&type=' + type).then(function (data) {
                _this.list = data.data.data.items;
            });
        }
    },
    components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2de654","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-aside/ranking-aside.vue
var ranking_aside_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.list.length != 0,
          expression: "list.length!=0"
        }
      ],
      staticClass: "aside-1"
    },
    [
      _c("dl", [
        _c("div", { staticClass: "title" }, [
          _c("i"),
          _vm._v(_vm._s(_vm.title) + "\n            "),
          _c("div", { staticClass: "rankType" }, [
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    _vm.getRewen("day")
                  }
                }
              },
              [_vm._v("日排行")]
            ),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    _vm.getRewen("week")
                  }
                }
              },
              [_vm._v("周排行")]
            ),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    _vm.getRewen("month")
                  }
                }
              },
              [_vm._v("月排行")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.list, function(item, index) {
        return _c("dd", { key: index }, [
          _c("div", { style: { color: index < 3 ? "#3dabfe" : "#666666" } }, [
            _vm._v(_vm._s(_vm.topNumber[index]))
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: item.open_type == 0 ? "/news/" + item.id : item.third_url
              }
            },
            [_vm._v(_vm._s(item.title))]
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.friendlyTime(item.released_at)))])
        ])
      }),
      _vm._v(" "),
      _c("span")
    ],
    2
  )
}
var ranking_aside_staticRenderFns = []
ranking_aside_render._withStripped = true
var ranking_aside_esExports = { render: ranking_aside_render, staticRenderFns: ranking_aside_staticRenderFns }
/* harmony default export */ var news_aside_ranking_aside = (ranking_aside_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-4a2de654", ranking_aside_esExports)
  }
}
// CONCATENATED MODULE: ./app/web/component/web/news-aside/ranking-aside.vue
var ranking_aside_disposed = false
function injectStyle (ssrContext) {
  if (ranking_aside_disposed) return
  __webpack_require__("deGw")
}
var ranking_aside_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ranking_aside___vue_template_functional__ = false
/* styles */
var ranking_aside___vue_styles__ = injectStyle
/* scopeId */
var ranking_aside___vue_scopeId__ = "data-v-4a2de654"
/* moduleIdentifier (server only) */
var ranking_aside___vue_module_identifier__ = null
var ranking_aside_Component = ranking_aside_normalizeComponent(
  ranking_aside,
  news_aside_ranking_aside,
  ranking_aside___vue_template_functional__,
  ranking_aside___vue_styles__,
  ranking_aside___vue_scopeId__,
  ranking_aside___vue_module_identifier__
)
ranking_aside_Component.options.__file = "app/web/component/web/news-aside/ranking-aside.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a2de654", ranking_aside_Component.options)
  } else {
    hotAPI.reload("data-v-4a2de654", ranking_aside_Component.options)
  }
  module.hot.dispose(function (data) {
    ranking_aside_disposed = true
  })
})()}

/* harmony default export */ var web_news_aside_ranking_aside = (ranking_aside_Component.exports);

// EXTERNAL MODULE: ./app/web/component/web/swiper/swiper.vue + 2 modules
var swiper = __webpack_require__("5zIS");

// EXTERNAL MODULE: ./app/web/component/web/news-list/public-list.vue + 2 modules
var public_list = __webpack_require__("cFQA");

// EXTERNAL MODULE: ./node_modules/date-fns/index.js
var date_fns = __webpack_require__("wuJz");
var date_fns_default = /*#__PURE__*/__webpack_require__.n(date_fns);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/web/page/news-pc/index.vue
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










/* harmony default export */ var news_pc = ({
  components: {
    Layout: news_layout["a" /* default */],
    newsAside: news_aside["a" /* default */],
    publicList: public_list["a" /* default */],
    swiper: swiper["a" /* default */],
    adAside: web_news_aside_ad_aside,
    rankingAside: web_news_aside_ranking_aside
  },
  data: function data() {
    return {
      showid: 0,
      page: 1,
      showMore: "加载更多"
    };
  },
  mounted: function mounted() {

    document.documentElement.scrollTop = document.documentElement.scrollTop + 1;

    var speed = 20;
    var tab = document.querySelector(".news_scroll .scroll_container");
    var tab1 = document.querySelector(".news_scroll .s1");
    var tab2 = document.querySelector(".news_scroll .s2");
    tab2.innerHTML = tab1.innerHTML;
    function Marquee() {
      if (tab2.offsetWidth - tab.scrollLeft <= 0) {
        tab.scrollLeft -= tab1.offsetWidth;
      } else {
        tab.scrollLeft++;
      }
    }

    clearInterval(MyMar);
    var MyMar = setInterval(Marquee, speed);
    tab.onmouseover = function () {
      clearInterval(MyMar);
    };
    tab.onmouseout = function () {
      MyMar = setInterval(Marquee, speed);
    };
  },

  methods: {
    more: function more() {
      var _this = this;

      this.page++;
      this.showMore = "加载中";
      axios["a" /* default */].get(api["a" /* default */].news + "?page=" + this.page + "&recommended=1").then(function (data) {
        _this.newsList = [].concat(_toConsumableArray(_this.newsList), _toConsumableArray(data.data.data.items));
        _this.pageList = data.data.data.items;
        _this.meta = data.data.data._meta;
        _this.showMore = "加载更多";
      });
    },
    clickAction: function clickAction(item) {
      console.log(item);
      if (item.third_url != "") {
        window.open(item.third_url);
      } else {
        window.open(location.origin + "/news/" + item.id);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c96d6c72","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/page/news-pc/index.vue
var news_pc_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    {
      attrs: {
        clientId: _vm.clientId,
        showid: 0,
        ads: _vm.ads,
        channels: _vm.channels,
        setTitle: _vm.title,
        apiOrigin: _vm.apiOrigin
      }
    },
    [
      _c("div", [
        _c("div", { staticClass: "backgroud1" }, [
          _c("div", { staticClass: "backgroud2" }, [
            _vm.newsBig && _vm.newsBig.length > 0
              ? _c("section", { staticClass: "headline" }, [
                  _c("div", { staticClass: "outer clear" }, [
                    _c("div", { staticClass: "lf" }, [
                      _c("div", [
                        _vm._v("\n                关"),
                        _c("br"),
                        _vm._v("\n                注\n              ")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "news" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.newsBig.length > 0,
                              expression: "newsBig.length > 0"
                            }
                          ],
                          staticClass: "bold",
                          staticStyle: { "font-size": "40px" }
                        },
                        _vm._l(_vm.newsBig, function(item, index) {
                          return _c(
                            "a",
                            {
                              key: index,
                              attrs: { type: item.id, target: "_blank" },
                              on: {
                                click: function($event) {
                                  _vm.clickAction(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.title))]
                          )
                        })
                      ),
                      _vm._v(" "),
                      _vm.newsSmall.length > 3
                        ? _c(
                            "div",
                            _vm._l(_vm.newsSmall, function(item, index) {
                              return _c(
                                "a",
                                {
                                  key: index,
                                  attrs: { type: item.id, target: "_blank" },
                                  on: {
                                    click: function($event) {
                                      _vm.clickAction(item)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.title))]
                              )
                            })
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.newsSmall, function(item, index) {
                              return _c(
                                "a",
                                {
                                  key: index,
                                  attrs: { type: item.id, target: "_blank" },
                                  on: {
                                    click: function($event) {
                                      _vm.clickAction(item)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.title))]
                              )
                            })
                          )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass: "outer news_scroll",
            staticStyle: { "padding-top": "22px", "padding-bottom": "0" }
          },
          [
            _vm.newsLunbo && _vm.newsLunbo.length > 0
              ? _c("div", { staticClass: "news_scroll" }, [
                  _c("div", { staticClass: "clear" }, [
                    _c("div", { staticClass: "scroll" }, [
                      _c("div", { staticClass: "lf" }, [_vm._v("滚 动")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rt" }, [
                        _c("div", { staticClass: "scroll_container" }, [
                          _c("div", { staticClass: "box" }, [
                            _c(
                              "div",
                              { staticClass: "s1" },
                              _vm._l(_vm.newsLunbo, function(item, index) {
                                return _c(
                                  "a",
                                  {
                                    key: index,
                                    attrs: { type: item.id, target: "_blank" },
                                    on: {
                                      click: function($event) {
                                        _vm.clickAction(item)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                )
                              })
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "s2" },
                              _vm._l(_vm.newsLunbo, function(item, index) {
                                return _c(
                                  "a",
                                  {
                                    key: index,
                                    attrs: { type: item.id, target: "_blank" },
                                    on: {
                                      click: function($event) {
                                        _vm.clickAction(item)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                )
                              })
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "article" },
          [
            _vm.ads.slide.items
              ? _c("swiper", {
                  attrs: { list: _vm.ads.slide.items, type: "1" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("publicList", {
              attrs: { list: _vm.newsList, clientId: _vm.clientId }
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.meta.page_count > _vm.meta.current_page,
                    expression: "meta.page_count > meta.current_page"
                  }
                ],
                staticClass: "more",
                attrs: {
                  disabled: _vm.showMore == "加载中",
                  href: "javascript:;",
                  id: "pc-more"
                },
                on: { click: _vm.more }
              },
              [_vm._v(_vm._s(_vm.showMore))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.newsList.length == 0 ||
                      _vm.meta.page_count == _vm.meta.current_page,
                    expression:
                      "newsList.length == 0 || meta.page_count == meta.current_page"
                  }
                ],
                staticClass: "more",
                attrs: { href: "javascript:;", id: "pc-more" }
              },
              [_vm._v("没有更多了")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "aside aside-bside" },
          [
            _c(
              "div",
              { staticClass: "aside aside-bside" },
              [
                _vm.clientId == 321300
                  ? _c("rankingAside", {
                      attrs: { list: _vm.reWenList, title: "排行榜" }
                    })
                  : _c("newsAside", {
                      attrs: { list: _vm.reWenList, title: "热文" }
                    }),
                _vm._v(" "),
                _vm.clientId !== 410600
                  ? _c("news-aside", {
                      attrs: { list: _vm.bianMinList, title: "便民" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("adAside", {
              attrs: { list: _vm.ads.slideBars, clientId: _vm.clientId }
            }),
            _vm._v(" "),
            _vm.clientId == 321300
              ? _c(
                  "a",
                  { attrs: { href: "https://www.12377.cn", target: "_blank" } },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "320px",
                        height: "95px",
                        display: "block",
                        margin: "0 auto"
                      },
                      attrs: { src: "/public/w/img/321300/jubao.jpg" }
                    })
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var news_pc_staticRenderFns = []
news_pc_render._withStripped = true
var news_pc_esExports = { render: news_pc_render, staticRenderFns: news_pc_staticRenderFns }
/* harmony default export */ var page_news_pc = (news_pc_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-c96d6c72", news_pc_esExports)
  }
}
// CONCATENATED MODULE: ./app/web/page/news-pc/index.vue
var news_pc_disposed = false
function news_pc_injectStyle (ssrContext) {
  if (news_pc_disposed) return
  __webpack_require__("VAwf")
}
var news_pc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var news_pc___vue_template_functional__ = false
/* styles */
var news_pc___vue_styles__ = news_pc_injectStyle
/* scopeId */
var news_pc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var news_pc___vue_module_identifier__ = null
var news_pc_Component = news_pc_normalizeComponent(
  news_pc,
  page_news_pc,
  news_pc___vue_template_functional__,
  news_pc___vue_styles__,
  news_pc___vue_scopeId__,
  news_pc___vue_module_identifier__
)
news_pc_Component.options.__file = "app/web/page/news-pc/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c96d6c72", news_pc_Component.options)
  } else {
    hotAPI.reload("data-v-c96d6c72", news_pc_Component.options)
  }
  module.hot.dispose(function (data) {
    news_pc_disposed = true
  })
})()}

/* harmony default export */ var web_page_news_pc = (news_pc_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./app/web/framework/vue/entry/client-loader.js!./app/web/page/news-pc/index.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var client_loader_js_app_web_page_news_pc = __webpack_exports__["default"] = (client["a" /* default */].render(_extends({}, web_page_news_pc)));

/***/ }),

/***/ "GvNH":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("WNGz")

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),

/***/ "HXCM":
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 *
 * @description
 * Return the end of tomorrow.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfTomorrow


/***/ }),

/***/ "I7cV":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setDate(date.getDate() + diff)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfWeek


/***/ }),

/***/ "JNsx":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate) {
  var date = parse(dirtyDate)
  var minutes = date.getMinutes()
  return minutes
}

module.exports = getMinutes


/***/ }),

/***/ "Javx":
/***/ (function(module, exports, __webpack_require__) {

var isLeapYear = __webpack_require__("b7g8")

/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate) {
  return isLeapYear(dirtyDate) ? 366 : 365
}

module.exports = getDaysInYear


/***/ }),

/***/ "Jtuq":
/***/ (function(module, exports, __webpack_require__) {

var getQuarter = __webpack_require__("lQzg")
var parse = __webpack_require__("xA5w")

/**
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)

  return yearDiff * 4 + quarterDiff
}

module.exports = differenceInCalendarQuarters


/***/ }),

/***/ "Jvcu":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),

/***/ "K7ZZ":
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__("zZbG")
var startOfISOWeek = __webpack_require__("3znZ")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
  date.setMilliseconds(date.getMilliseconds() - 1)
  return date
}

module.exports = endOfISOYear


/***/ }),

/***/ "LLTj":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(0, 0, 0)
  return date
}

module.exports = startOfHour


/***/ }),

/***/ "LU20":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(59, 999)
  return date
}

module.exports = endOfMinute


/***/ }),

/***/ "M5Oo":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(0, 0)
  return date
}

module.exports = startOfMinute


/***/ }),

/***/ "M9Ev":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Day Helpers
 * @summary Return the array of dates within the specified range.
 *
 * @description
 * Return the array of dates within the specified range.
 *
 * @param {Date|String|Number} startDate - the first date
 * @param {Date|String|Number} endDate - the last date
 * @param {Number} [step=1] - the step between each day
 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDay(
 *   new Date(2014, 9, 6),
 *   new Date(2014, 9, 10)
 * )
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
  var startDate = parse(dirtyStartDate)
  var endDate = parse(dirtyEndDate)
  var step = dirtyStep !== undefined ? dirtyStep : 1

  var endTime = endDate.getTime()

  if (startDate.getTime() > endTime) {
    throw new Error('The first date cannot be after the second date')
  }

  var dates = []

  var currentDate = startDate
  currentDate.setHours(0, 0, 0, 0)

  while (currentDate.getTime() <= endTime) {
    dates.push(parse(currentDate))
    currentDate.setDate(currentDate.getDate() + step)
  }

  return dates
}

module.exports = eachDay


/***/ }),

/***/ "MIQa":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfDay


/***/ }),

/***/ "MKc+":
/***/ (function(module, exports, __webpack_require__) {

var addISOYears = __webpack_require__("oNnY")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addISOYears(dirtyDate, -amount)
}

module.exports = subISOYears


/***/ }),

/***/ "Mbb9":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),

/***/ "Mdww":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),

/***/ "Moxe":
/***/ (function(module, exports, __webpack_require__) {

var startOfMinute = __webpack_require__("M5Oo")

/**
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}

module.exports = isSameMinute


/***/ }),

/***/ "NKE6":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),

/***/ "NSOL":
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__("6Zhv")

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
}

module.exports = addMinutes


/***/ }),

/***/ "Pbpa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: '/news/api/v4/'
});
/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),

/***/ "Q2rx":
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__("u/4p")

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarWeeks


/***/ }),

/***/ "Qbo9":
/***/ (function(module, exports, __webpack_require__) {

var isSameMinute = __webpack_require__("Moxe")

/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute (dirtyDate) {
  return isSameMinute(new Date(), dirtyDate)
}

module.exports = isThisMinute


/***/ }),

/***/ "Qxz6":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

module.exports = isSameYear


/***/ }),

/***/ "SHOI":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var addDays = __webpack_require__("Jvcu")

/**
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = date.getDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
  return addDays(date, diff)
}

module.exports = setDay


/***/ }),

/***/ "SZZR":
/***/ (function(module, exports, __webpack_require__) {

var endOfWeek = __webpack_require__("I7cV")

/**
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate) {
  return endOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = endOfISOWeek


/***/ }),

/***/ "T/Ln":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfQuarter


/***/ }),

/***/ "ToRI":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds setted
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds) {
  var date = parse(dirtyDate)
  var seconds = Number(dirtySeconds)
  date.setSeconds(seconds)
  return date
}

module.exports = setSeconds


/***/ }),

/***/ "Tv4R":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = currentDate
      minDistance = distance
    }
  })

  return result
}

module.exports = closestTo


/***/ }),

/***/ "Uu+E":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var startOfISOYear = __webpack_require__("iRXW")
var differenceInCalendarDays = __webpack_require__("nizW")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year setted
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear) {
  var date = parse(dirtyDate)
  var isoYear = Number(dirtyISOYear)
  var diff = differenceInCalendarDays(date, startOfISOYear(date))
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(isoYear, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  date = startOfISOYear(fourthOfJanuary)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = setISOYear


/***/ }),

/***/ "VAwf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VaeB":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(0)
  return date
}

module.exports = startOfSecond


/***/ }),

/***/ "XFzU":
/***/ (function(module, exports, __webpack_require__) {

var differenceInMonths = __webpack_require__("GI7G")

/**
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInQuarters


/***/ }),

/***/ "YPf8":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate) {
  return parse(dirtyDate).getDay() === 5
}

module.exports = isFriday


/***/ }),

/***/ "YPjl":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var addDays = __webpack_require__("Jvcu")
var getISODay = __webpack_require__("AZvW")

/**
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay) {
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = getISODay(date)
  var diff = day - currentDay
  return addDays(date, diff)
}

module.exports = setISODay


/***/ }),

/***/ "YRFD":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareDesc


/***/ }),

/***/ "ZUMa":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate) {
  return parse(dirtyDate).getDay() === 0
}

module.exports = isSunday


/***/ }),

/***/ "a7Cs":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse(dirtyDate)
  var year = Number(dirtyYear)
  date.setFullYear(year)
  return date
}

module.exports = setYear


/***/ }),

/***/ "aHtT":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var earliestTimestamp = Math.min.apply(null, dates)
  return new Date(earliestTimestamp)
}

module.exports = min


/***/ }),

/***/ "b7g8":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}

module.exports = isLeapYear


/***/ }),

/***/ "balU":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var getDaysInMonth = __webpack_require__("Mdww")

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse(dirtyDate)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

module.exports = setMonth


/***/ }),

/***/ "bbdo":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(59, 59, 999)
  return date
}

module.exports = endOfHour


/***/ }),

/***/ "bqqu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./app/web/asset/news-pc/js/api.js
var api = __webpack_require__("hkaH");

// EXTERNAL MODULE: ./app/web/asset/news-pc/js/axios.js
var js_axios = __webpack_require__("Pbpa");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/web/component/web/news-layout/header/header.vue




/* harmony default export */ var header = ({
  data: function data() {
    return {
      isShow: false,
      isQR: false,
      iswxQR: false,
      searchKeys: '',
      searchShow: false,
      cityMessage: {
        410600: {
          herf: '//www.hebitv.com',
          message: '扫一扫下载无限鹤壁APP',
          ewm: true,
          wx: false,
          wxMessage: '',
          logo: '/public/w/img/410600/logo_news.png',
          cityId: 'WW372S04V500',
          weather: {
            "flavor": "slim",
            "location": "WW372S04V500",
            "geolocation": "disabled",
            "language": "zh-chs",
            "unit": "c",
            "theme": "chameleon",
            "container": "tp-weather-widget",
            "bubble": "disabled",
            "alarmType": "circle",
            "uid": "U320722CA0",
            "hash": "c68e81537eaadb9743969449b0f8c021"
          },
          cityName: 'hebi'
        }
      }
    };
  },

  props: {
    showid: {
      default: 0
    },
    channels: {
      default: []
    },
    clientId: {
      default: 0
    },
    ads: {
      default: {}
    }
  },
  computed: {
    channelHideLimit: function channelHideLimit() {
      return this.$root.channelHideLimit;
    }
  },
  updated: function updated() {},
  mounted: function mounted() {
    if (this.channels.length > this.channelHideLimit) {
      if (this.channelHideLimit !== this.channels.length) {
        var offsetLeft = this.$refs.more.offsetLeft;

        this.$refs.spread.style.left = offsetLeft - 30 + 'px';
      }
    }

    var _html = '<iframe style="top: -20px; position: relative;" frameborder="0" scrolling="no" hspace="0" src="https://i.tianqi.com/?c=code&a=getcode&id=31&h=95&w=80&py=' + this.cityMessage[this.clientId].cityName + '"></iframe>';
    this.$refs.weather.innerHTML = _html;
  },

  methods: {
    doSearch: function doSearch() {
      var keywords = this.searchKeys.replace(/ /g, '');
      location.href = location.origin + '/news/searchResult?keywords=' + encodeURIComponent(keywords);
    },
    setShow: function setShow(bl) {
      this.isShow = bl;
    },
    setQR: function setQR(bl) {
      this.isQR = bl;
    },
    setwxQR: function setwxQR(bl) {
      this.iswxQR = bl;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-619ab4e0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-layout/header/header.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "cover",
        staticStyle: { height: "1702px" },
        style: { display: _vm.searchShow ? "block" : "none" },
        on: {
          click: function($event) {
            _vm.searchShow = false
          }
        }
      },
      [
        _c("div", { staticClass: "hidden" }, [
          _vm.ads.banner1 && _vm.ads.banner1.items
            ? _c("div", { staticClass: "top" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.ads.banner1.items[0].url,
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.ads.banner1.items[0].images[0].url }
                    })
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.ads.banner2 && _vm.ads.banner2.items
            ? _c("div", { staticClass: "top" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.ads.banner2.items[0].url,
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.ads.banner2.items[0].images[0].url }
                    })
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.ads.banner3 && _vm.ads.banner3.items
            ? _c("div", { staticClass: "top" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.ads.banner3.items[0].url,
                      target: "_blank"
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.ads.banner3.items[0].images[0].url }
                    })
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "header",
            staticStyle: { "border-bottom": "none" },
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "main clear",
                staticStyle: { background: "rgb(255, 255, 255)" }
              },
              [
                _c("div", { staticClass: "logo" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.cityMessage[_vm.clientId].herf } },
                    [
                      _c("img", {
                        attrs: { src: _vm.cityMessage[_vm.clientId].logo }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "searchlist" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchKeys,
                        expression: "searchKeys"
                      }
                    ],
                    staticClass: "searchInput",
                    attrs: {
                      type: "text",
                      id: "keyword",
                      name: "keyword",
                      placeholder: "",
                      value: ""
                    },
                    domProps: { value: _vm.searchKeys },
                    on: {
                      keyup: function($event) {
                        if (!("button" in $event) && $event.keyCode !== 13) {
                          return null
                        }
                        _vm.doSearch()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchKeys = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: "/public/w/img/pc/search-03.png", alt: "" },
                    on: {
                      click: function($event) {
                        _vm.doSearch()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "searchClose",
                    attrs: { src: "/public/w/img/pc/close.png", alt: "" },
                    on: {
                      click: function($event) {
                        _vm.searchKeys = ""
                      }
                    }
                  })
                ])
              ]
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("header", { staticClass: "header" }, [
      _c("div", [
        _vm.ads.banner1 && _vm.ads.banner1.items && _vm.clientId == 320598
          ? _c(
              "div",
              _vm._l(_vm.ads.banner1.items, function(item, index) {
                return _c("div", { key: index, staticClass: "top" }, [
                  _c("a", { attrs: { href: item.url } }, [
                    _c("img", { attrs: { src: item.images[0].url } })
                  ])
                ])
              })
            )
          : _c("div", [
              _vm.ads.banner1 && _vm.ads.banner1.items
                ? _c("div", { staticClass: "top" }, [
                    _c("a", { attrs: { href: _vm.ads.banner1.items[0].url } }, [
                      _c("img", {
                        attrs: { src: _vm.ads.banner1.items[0].images[0].url }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.ads.banner2 && _vm.ads.banner2.items
                ? _c("div", { staticClass: "top" }, [
                    _c("a", { attrs: { href: _vm.ads.banner2.items[0].url } }, [
                      _c("img", {
                        attrs: { src: _vm.ads.banner2.items[0].images[0].url }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.ads.banner3 && _vm.ads.banner3.items
                ? _c("div", { staticClass: "top" }, [
                    _c("a", { attrs: { href: _vm.ads.banner3.items[0].url } }, [
                      _c("img", {
                        attrs: { src: _vm.ads.banner3.items[0].images[0].url }
                      })
                    ])
                  ])
                : _vm._e()
            ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "header common",
          staticStyle: { visibility: "visible" }
        },
        [
          _c("div", { staticClass: "main clear" }, [
            _c("div", { staticClass: "logo" }, [
              _c("a", { attrs: { href: _vm.cityMessage[_vm.clientId].herf } }, [
                _c("img", {
                  attrs: { src: _vm.cityMessage[_vm.clientId].logo }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "menu" }, [
              _c(
                "div",
                _vm._l(_vm.channels, function(item, index) {
                  return index < _vm.channelHideLimit
                    ? _c(
                        "li",
                        { key: index, class: { on: item.id == _vm.showid } },
                        [
                          item.id != _vm.showid && !item.isChain
                            ? _c("a", { attrs: { href: item.url } }, [
                                _vm._v(_vm._s(item.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.id == _vm.showid && !item.isChain
                            ? _c("a", [_vm._v(_vm._s(item.name))])
                            : _vm._e(),
                          _vm._v(" "),
                          item.id != _vm.showid && item.isChain
                            ? _c(
                                "a",
                                { attrs: { target: "_blank", href: item.url } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.id == _vm.showid && item.isChain
                            ? _c("a", { attrs: { target: "_blank" } }, [
                                _vm._v(_vm._s(item.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("i")
                        ]
                      )
                    : _vm._e()
                })
              ),
              _vm._v(" "),
              _vm.channels.length > _vm.channelHideLimit
                ? _c(
                    "li",
                    {
                      ref: "more",
                      staticClass: "only",
                      class: { on: _vm.isShow },
                      on: {
                        mousemove: function($event) {
                          _vm.setShow(true)
                        },
                        mouseout: function($event) {
                          _vm.setShow(false)
                        }
                      }
                    },
                    [
                      _c("a", [_vm._v("更多")]),
                      _vm._v(" "),
                      _c("span"),
                      _vm._v(" "),
                      _c("i")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("i", { staticClass: "excision" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "spread",
                  staticClass: "spread",
                  class: { on: _vm.isShow },
                  on: {
                    mousemove: function($event) {
                      _vm.setShow(true)
                    },
                    mouseout: function($event) {
                      _vm.setShow(false)
                    }
                  }
                },
                [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.channels, function(item, index) {
                      return index >= _vm.channelHideLimit
                        ? _c("span", [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.id != _vm.showid,
                                    expression: "item.id!=showid"
                                  }
                                ],
                                attrs: { href: item.url, target: "_blank" }
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.id == _vm.showid,
                                    expression: "item.id==showid"
                                  }
                                ],
                                staticClass: "on",
                                attrs: { target: "_blank" }
                              },
                              [_vm._v(_vm._s(item.name))]
                            )
                          ])
                        : _vm._e()
                    })
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "search",
              on: {
                click: function($event) {
                  _vm.searchShow = true
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              ref: "weather",
              staticClass: "weather",
              attrs: { id: "tp-weather-widget" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "code" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cityMessage[_vm.clientId].ewm,
                      expression: "cityMessage[clientId].ewm"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "app" }, [
                    _c(
                      "span",
                      {
                        on: {
                          mousemove: function($event) {
                            _vm.setQR(true)
                          },
                          mouseout: function($event) {
                            _vm.setQR(false)
                          }
                        }
                      },
                      [_vm._v("APP下载\n                "), _c("span")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "share",
                      style: { display: _vm.isQR ? "block" : "none" }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/public/w/img/410600/app.jpg" }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("iphone & Android")]),
                      _vm._v(" "),
                      _c("span", [_vm._v("扫一扫下载无限鹤壁APP")])
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "code" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cityMessage[_vm.clientId].wx,
                      expression: "cityMessage[clientId].wx"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "app" }, [
                    _c(
                      "span",
                      {
                        on: {
                          mousemove: function($event) {
                            _vm.setwxQR(true)
                          },
                          mouseout: function($event) {
                            _vm.setwxQR(false)
                          }
                        }
                      },
                      [_vm._v("公众号\n                "), _c("span")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "share",
                      style: { display: _vm.iswxQR ? "block" : "none" }
                    },
                    [
                      _c("img", {
                        attrs: { src: _vm.cityMessage[_vm.clientId].wx }
                      }),
                      _vm._v(" "),
                      _c("p"),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.cityMessage[_vm.clientId].wxMessage))
                      ]),
                      _vm._v(" "),
                      _vm._m(0)
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", [
      _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var header_header = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-619ab4e0", esExports)
  }
}
// CONCATENATED MODULE: ./app/web/component/web/news-layout/header/header.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("pWdO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  header,
  header_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "app/web/component/web/news-layout/header/header.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-619ab4e0", Component.options)
  } else {
    hotAPI.reload("data-v-619ab4e0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var news_layout_header_header = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/web/component/web/news-layout/footer/footer.vue


/* harmony default export */ var footer = ({
  props: ['clientId'],
  data: function data() {
    return {
      host: '#'
    };
  },
  mounted: function mounted() {
    console.log(this.clientId);
    this.host = location.origin;
    var _window$location = window.location,
        pathname = _window$location.pathname,
        hash = _window$location.hash;

    this.selectedMenu = pathname.toLowerCase() + hash.toLowerCase();

    var footer = this.$refs.footer;
    var setFooterMarginTop = function setFooterMarginTop() {
      var clientHeight = document.documentElement.clientHeight;
      var offsetTop = footer.offsetTop;

      var marginTop = footer.style.marginTop.replace('px', '') * 1;
      if (isNaN(marginTop)) {
        marginTop = 0;
      }
      marginTop = Math.max(0, marginTop);
      var newMarginTop = Math.max(clientHeight - offsetTop - footer.clientHeight + marginTop, 0);
      if (newMarginTop != marginTop) {
        footer.style.marginTop = newMarginTop + 'px';
      }
    };
    window.onresize = setFooterMarginTop;
    setFooterMarginTop();
  },

  methods: {
    smoothscroll: function smoothscroll() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3788cc60","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-layout/footer/footer.vue
var footer_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "footer" },
    [
      _vm._t("bottom"),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [
        _vm.clientId == 320684
          ? _c("div", { staticClass: "main" }, [
              _c("div", { staticClass: "service clear" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("dl", { staticClass: "service-2" }, [
                  _c("dt", [_vm._v("关于我们")]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "http://wwwvideo.jshmtv.com/web/program/about#jianjie"
                        }
                      },
                      [_vm._v("关于我们")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "http://wwwvideo.jshmtv.com/web/program/about#xinwen"
                        }
                      },
                      [_vm._v("新闻热线")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "http://wwwvideo.jshmtv.com/web/program/about#guanggao"
                        }
                      },
                      [_vm._v("广告服务")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2)
              ]),
              _vm._v(" "),
              _vm._m(3)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 320598
          ? _c("div", { staticClass: "main" }, [
              _c("div", { staticClass: "service clear" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("dl", { staticClass: "service-2" }, [
                  _c("dt", [_vm._v("关于我们")]),
                  _vm._v(" "),
                  _c("dd", [
                    _c("a", { attrs: { href: _vm.host + "/news/about" } }, [
                      _vm._v("关于我们")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      { attrs: { href: _vm.host + "/news/about#rexian" } },
                      [_vm._v("新闻热线")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      { attrs: { href: _vm.host + "/news/about#guanggao" } },
                      [_vm._v("广告服务")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _vm._m(6)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "copy" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("img", {
                  staticStyle: {
                    "vertical-align": "middle",
                    "margin-left": "10px",
                    height: "20px"
                  },
                  attrs: { src: "/public/w/img/pc/beianlogo.png" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "share clear" }, [
                  _c(
                    "div",
                    {
                      staticClass: "bdsharebuttonbox bdshare-button-style0-32"
                    },
                    [
                      _c("a", {
                        staticClass: "top_btn",
                        staticStyle: { display: "inline-block" },
                        on: {
                          click: function($event) {
                            _vm.smoothscroll()
                          }
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(8)
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 410600
          ? _c("div", { staticClass: "footer-tag-list main center" }, [
              _c("div", { staticClass: "service  clear" }, [
                _c("div", [
                  _c("a", { attrs: { href: _vm.host + "/news/about" } }, [
                    _vm._v("关于我们")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.henanjubao.com/",
                        target: "_black"
                      }
                    },
                    [_vm._v("河南省互联网违法和不良信息举报中心")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: { href: "http://www.12377.cn", target: "_black" }
                    },
                    [_vm._v("中国互联网违法和不良信息举报中心入口")]
                  ),
                  _vm._v(" "),
                  _c("a", [_vm._v("举报电话:0392-3331766")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41061102000115",
                        target: "_black"
                      }
                    },
                    [_vm._v("豫公网安备 41061102000115号")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "copy" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "share clear" }, [
                  _c(
                    "div",
                    {
                      staticClass: "bdsharebuttonbox bdshare-button-style0-32"
                    },
                    [
                      _c("a", {
                        staticClass: "top_btn",
                        staticStyle: { display: "inline-block" },
                        on: {
                          click: function($event) {
                            _vm.smoothscroll()
                          }
                        }
                      })
                    ]
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 321300
          ? _c("div", { staticClass: "footer-tag-list main center" }, [
              _vm._m(10),
              _vm._v(" "),
              _vm._m(11)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 320100
          ? _c("div", { staticClass: "main" }, [
              _c("div", { staticClass: "service clear" }, [
                _vm._m(12),
                _vm._v(" "),
                _c("dl", { staticClass: "service-2" }, [
                  _c("dt", [_vm._v("关于我们")]),
                  _vm._v(" "),
                  _c("dd", [
                    _c("a", { attrs: { href: _vm.host + "/news/about" } }, [
                      _vm._v("关于我们")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      { attrs: { href: _vm.host + "/news/about#rexian" } },
                      [_vm._v("新闻热线")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("dd", [
                    _c(
                      "a",
                      { attrs: { href: _vm.host + "/news/about#guanggao" } },
                      [_vm._v("广告服务")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(13),
                _vm._v(" "),
                _c("div", { staticClass: "copy" }, [
                  _c("p", [_vm._v("版权所有 © 南京晨报社")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "share clear" }, [
                    _c(
                      "div",
                      {
                        staticClass: "bdsharebuttonbox bdshare-button-style0-32"
                      },
                      [
                        _c("a", {
                          staticClass: "top_btn",
                          staticStyle: { display: "inline-block" },
                          on: {
                            click: function($event) {
                              _vm.smoothscroll()
                            }
                          }
                        })
                      ]
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.clientId == 410900
          ? _c("div", { staticClass: "footer-tag-list main center" }, [
              _vm._m(14),
              _vm._v(" "),
              _vm._m(15),
              _vm._v(" "),
              _vm._m(16),
              _vm._v(" "),
              _vm._m(17)
            ])
          : _vm._e()
      ])
    ],
    2
  )
}
var footer_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-1" }, [
      _c("dt", [_vm._v("产品和服务")]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "http://www.jshmzc.com/", target: "_black" } },
          [_vm._v("海门之窗")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("东洲城事")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { left: "50px", top: "125px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320684/dzcs.png" } }),
            _vm._v(" "),
            _c("p", [_vm._v("iphone & Android")]),
            _vm._v(" "),
            _c("span", [_vm._v("微信扫一扫 东洲城事")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("dd", { staticStyle: { left: "50px", top: "130px" } }, [
        _c(
          "a",
          { attrs: { href: "http://gdt.haimen.gov.cn/", target: "_black" } },
          [_vm._v("海门市广播电视台")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("广电之星")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { left: "50px", top: "170px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320684/gdzx.jpg" } }),
            _vm._v(" "),
            _c("p", [_vm._v("iphone & Android")]),
            _vm._v(" "),
            _c("span", [_vm._v("微信扫一扫 广电之星")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("海门日报")]),
        _vm._v(" "),
        _c("div", { staticClass: "qrcode", staticStyle: { top: "210px" } }, [
          _c("img", { attrs: { src: "/public/w/img/320684/hmrb.jpg" } }),
          _vm._v(" "),
          _c("p", [_vm._v("iphone & Android")]),
          _vm._v(" "),
          _c("span", [_vm._v("微信扫一扫 海门日报")]),
          _vm._v(" "),
          _c("i", [
            _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("FM100.6")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { left: "50px", top: "210px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320684/fm1006.jpg" } }),
            _vm._v(" "),
            _c("p", [_vm._v("iphone & Android")]),
            _vm._v(" "),
            _c("span", [_vm._v("微信扫一扫 FM100.6海门广播")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("dd"),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("海门电视台教育频道")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { left: "50px", top: "255px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320684/edu.png" } }),
            _vm._v(" "),
            _c("p", [_vm._v("iphone & Android")]),
            _vm._v(" "),
            _c("span", [_vm._v("微信扫一扫 海门电视台教育频道")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-3" }, [
      _c("dt", [_vm._v("免责声明")]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "本网站所刊登、转载的各种图片、稿件是为传播更多的信息，本网不承担此类稿件侵权行为的连带责任。"
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v("如您因版权等问题需要与本网联络，请在30日内联系我们。")
      ]),
      _vm._v(" "),
      _c("dd", [_vm._v("本网站法律顾问：江苏剑桥人律师事务所严文戟律师")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-4" }, [
      _c("dt", [_vm._v("APP下载")]),
      _vm._v(" "),
      _c("dd", [
        _c("img", { attrs: { src: "/public/w/img/320684/download.jpg" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copy" }, [
      _c("p", [
        _vm._v("版权所有 © 海门电视台 2018 "),
        _c(
          "a",
          {
            staticStyle: {
              color: "#ffffff",
              display: "inline-block",
              "text-decoration": "none",
              height: "20px",
              "line-height": "20px"
            },
            attrs: { target: "blank", href: "http://www.beian.miit.gov.cn" }
          },
          [_vm._v("苏ICP备17033365号")]
        ),
        _vm._v(" 苏新网备2008040号 "),
        _c(
          "a",
          {
            staticStyle: {
              color: "#ffffff",
              display: "inline-block",
              "text-decoration": "none",
              height: "20px",
              "line-height": "20px"
            },
            attrs: {
              target: "_blank",
              href:
                "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32068402000163"
            }
          },
          [_vm._v("苏公网安备 32068402000163号")]
        )
      ]),
      _vm._v(" "),
      _c("img", {
        staticStyle: {
          "vertical-align": "middle",
          "margin-left": "10px",
          height: "20px"
        },
        attrs: { src: "/public/w/img/pc/beianlogo.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-1" }, [
      _c("dt", [_vm._v("产品和服务")]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "https://www.wjdaily.com/", target: "_black" } },
          [_vm._v("吴江新闻网")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          {
            attrs: {
              href: "http://bbs.wjdaily.com/bbs/portal.php",
              target: "_black"
            }
          },
          [_vm._v("东太湖论坛")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("今吴江客户端")]),
        _vm._v(" "),
        _c("div", { staticClass: "qrcode", staticStyle: { top: "170px" } }, [
          _c("img", { attrs: { src: "/public/w/img/320598/ewm.png" } }),
          _vm._v(" "),
          _c("p", [_vm._v("iphone & Android")]),
          _vm._v(" "),
          _c("span", [_vm._v("扫一扫下载今吴江APP")]),
          _vm._v(" "),
          _c("i", [
            _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "http://epaper.ljwj150.com", target: "_black" } },
          [_vm._v("吴江日报数字报")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "http://weibo.com/lejuwj", target: "_black" } },
          [_vm._v("苏州吴江发布微博")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("融媒吴江")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { top: "215px", left: "29px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320598/wjrb.jpg" } }),
            _vm._v(" "),
            _c("span", [_vm._v("扫一扫关注融媒吴江")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-3" }, [
      _c("dt", [_vm._v("免责声明")]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "本网站所刊登、转载的各种图片、稿件是为传播更多的信息，本网不承担此类稿件侵权行为的连带责任。"
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v("如您因版权等问题需要与本网联络，请在30日内联系我们。")
      ]),
      _vm._v(" "),
      _c("dd", [_vm._v("本网站法律顾问：江苏剑桥人律师事务所严文戟律师")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-4" }, [
      _c("dt", [_vm._v("APP下载")]),
      _vm._v(" "),
      _c("dd", [_c("img", { attrs: { src: "/public/w/img/320598/ewm.png" } })]),
      _vm._v(" "),
      _c("dd", [_vm._v("今吴江")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("版权所有 © 吴江融媒体中心 2019 "),
      _c(
        "a",
        {
          staticStyle: {
            color: "#ffffff",
            display: "inline-block",
            "text-decoration": "none",
            height: "20px",
            "line-height": "20px"
          },
          attrs: { target: "blank", href: "http://www.beian.miit.gov.cn" }
        },
        [_vm._v("苏ICP备10217754号")]
      ),
      _vm._v(" 苏新网备2008040号 "),
      _c(
        "a",
        {
          staticStyle: {
            color: "#ffffff",
            display: "inline-block",
            "text-decoration": "none",
            height: "20px",
            "line-height": "20px"
          },
          attrs: {
            target: "_blank",
            href:
              "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050902100461 &#10;&#10;"
          }
        },
        [_vm._v("苏公网安备 32050902100461号")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "map" }, [
      _c("div", { staticClass: "tel" }, [
        _c("div", { staticClass: "tel1" }),
        _vm._v(" "),
        _c("div", { staticClass: "tel2" }, [
          _c("a", { attrs: { href: "http://www.12377.cn/", target: "_blank" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tel3" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fri-link" }, [
        _c("div", { staticClass: "link1" }, [
          _c("a", {
            attrs: {
              href:
                "http://bszs.conac.cn/sitename?method=show&id=540510F517164DF6E053022819AC95AE",
              target: "_blank"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "link2" }, [
          _c("a", {
            attrs: {
              href: "http://61.155.26.218/license?id=9207",
              target: "_blank"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "link3" }),
        _vm._v(" "),
        _c("div", { staticClass: "link4" }, [
          _c("a", { attrs: { href: "http://www.12315.cn/", target: "_blank" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "link5" }, [
          _c("a", {
            attrs: {
              href: "http://61.155.26.218/license/credit?id=9207",
              target: "_blank"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "link6" }, [
          _c("a", {
            attrs: {
              href: "http://61.155.26.218/license/credit?id=9207",
              target: "_blank"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("版权所有 © 鹤壁市广播电视台\n            "),
      _c(
        "a",
        {
          attrs: {
            href:
              "http://bszs.conac.cn/sitename?method=show&id=0EC7E26666AF726AE053022819AC80CC",
            target: "_black"
          }
        },
        [
          _c("img", {
            attrs: { src: "http://dcs.conac.cn/image/blue.png", alt: "" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://beian.miit.gov.cn/#/Integrated/index",
            target: "_black"
          }
        },
        [
          _vm._v(
            "\n              2018 豫ICP备05017900号-1 | 互联网视听节目服务 ( AVSP ): 豫网备 2016002 号\n              "
          )
        ]
      ),
      _vm._v(" "),
      _c("a", { attrs: { href: "javascript:;" } }, [
        _vm._v("互联网新闻许可证: 41120180010")
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticStyle: {
            "text-decoration": "none",
            width: "200px",
            "line-height": "106px",
            display: "block",
            margin: "auto"
          },
          attrs: {
            id: "_xinchacharenzheng_cert_vip_kexinweb",
            target: "_blank",
            href: "https://myssl.com/seal/detail?domain=www.hebitv.com"
          }
        },
        [
          _c("img", {
            staticStyle: { height: "106px", width: "200px" },
            attrs: {
              src:
                "https://sealres.myssl.com/seal/img/2x/seal.png?domain=www.hebitv.com"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { attrs: { href: "https://www.12377.cn", target: "_blank" } },
      [
        _c("img", {
          staticStyle: {
            width: "1010px",
            height: "65px",
            display: "block",
            margin: "20px auto 0"
          },
          attrs: { src: "/public/w/img/321300/jubao.png" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom bottomsq" }, [
      _c("div", { staticClass: "fo_con" }, [
        _c("div", { staticClass: "fo1" }, [_vm._v("Copyright © 2018")]),
        _vm._v(" "),
        _c("div", { staticClass: "fo2" }, [
          _vm._v("中共宿迁市委宣传部\n              "),
          _c("br"),
          _vm._v("宿迁报业网络传媒有限公司")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "fo3", staticStyle: { "line-height": "19px" } },
          [
            _c(
              "a",
              {
                staticStyle: {
                  display: "block",
                  "margin-top": "20px",
                  "font-size": "12px"
                },
                attrs: { href: "https://beian.miit.gov.cn/" }
              },
              [_vm._v("备案号：苏ICP备10105892号-14")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticStyle: { display: "block", "font-size": "12px" },
                attrs: { href: "javascript:;" }
              },
              [_vm._v("互联网新闻许可：32120180020")]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "fo4" }, [
          _vm._v(" 违法信息举报电话：0527-84389919\n              "),
          _c("br"),
          _vm._v(
            "违法信息举报邮箱：suxinwen2015@126.com              \n            "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fo5" }, [
          _vm._v("Powered by\n              "),
          _c("a", { attrs: { href: "#" } }, [_vm._v("速新闻")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-1" }, [
      _c("dt", [_vm._v("产品和服务")]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("爱南京客户端")]),
        _vm._v(" "),
        _c("div", { staticClass: "qrcode", staticStyle: { top: "120px" } }, [
          _c("img", { attrs: { src: "/public/w/img/320100/ewm.png" } }),
          _vm._v(" "),
          _c("p", [_vm._v("iphone & Android")]),
          _vm._v(" "),
          _c("span", [_vm._v("扫一扫下载爱南京APP")]),
          _vm._v(" "),
          _c("i", [
            _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("南京晨报小记者")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { top: "120px", left: "50px" }
          },
          [
            _c("img", { attrs: { src: "/public/w/img/320100/xiaojizhe.png" } }),
            _vm._v(" "),
            _c("span", [_vm._v("扫一扫关注小记者")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("南京晨报微信")]),
        _vm._v(" "),
        _c("div", { staticClass: "qrcode", staticStyle: { top: "165px" } }, [
          _c("img", { attrs: { src: "/public/w/img/320100/weixin.png" } }),
          _vm._v(" "),
          _c("span", [_vm._v("扫一扫关注南京晨报")]),
          _vm._v(" "),
          _c("i", [
            _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd", [
        _c("a", [_vm._v("南京晨报乔医生")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "qrcode",
            staticStyle: { top: "165px", left: "50px" }
          },
          [
            _c("img", {
              attrs: { src: "/public/w/img/320100/doctorqiao.png" }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("扫一扫关注乔医生")]),
            _vm._v(" "),
            _c("i", [
              _c("img", { attrs: { src: "/public/w/img/pc/index_03.png" } })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "https://www.inanjin.com/", target: "_black" } },
          [_vm._v("南京晨报网")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          { attrs: { href: "http://njcb.jschina.com.cn", target: "_black" } },
          [_vm._v("南京晨报数字报")]
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _c(
          "a",
          {
            attrs: {
              href: "https://weibo.com/nanjingchenbao?topnav=1&topsug=1",
              target: "_black"
            }
          },
          [_vm._v("南京晨报微博")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "service-3" }, [
      _c("dt", [_vm._v("免责声明")]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "本网站所刊登、转载的各种图片、稿件是为传播更多的信息，本网不承担此类稿件侵权行为的连带责任。"
        )
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v("如您因版权等问题需要与本网联络，请在30日内联系我们。")
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm._v(
          "任何媒体不得擅自转载本网站由其他单位提供的信息和服务内容，如需转载，必须与本网站联系获得合法授权。"
        )
      ]),
      _vm._v(" "),
      _c("dd", [_vm._v("举报电话：025-58682396")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "service  clear" }, [
      _c("div", [
        _c("a", { attrs: { href: "http://www.12377.cn", target: "_black" } }, [
          _vm._v("中国互联网违法和不良信息举报中心入口")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "https://www.henanjubao.com/", target: "_black" } },
          [_vm._v("河南省互联网违法和不良信息举报中心")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.pyxww.com/pyshlwjbzx/",
              target: "_black"
            }
          },
          [_vm._v("濮阳市互联网违法和不良信息举报中心")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "service  clear", staticStyle: { "padding-top": "0" } },
      [
        _c(
          "a",
          { staticStyle: { cursor: "auto" }, attrs: { href: "javascript:;" } },
          [_vm._v("违法和不良信息举报电话：0393-4690809")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { staticStyle: { cursor: "auto" }, attrs: { href: "javascript:;" } },
          [_vm._v("涉未成年人举报电话：0393-4690809")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { staticStyle: { cursor: "auto" }, attrs: { href: "javascript:;" } },
          [_vm._v("举报邮箱:pytvxmt@qq.com")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "service  clear", staticStyle: { "padding-top": "0" } },
      [
        _c(
          "a",
          {
            staticStyle: { "text-decoration": "none" },
            attrs: {
              id: "_xinchacharenzheng_cert_vip_ssl",
              target: "_blank",
              href:
                "https://xyt.xinchacha.com/getpcInfo?sn=1400380390676688896&certType=8"
            }
          },
          [
            _c("img", {
              staticStyle: { height: "50px", width: "164px" },
              attrs: { src: "https://xyt.xinchacha.com/img/icon/icon8.png" }
            })
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copy" }, [
      _c("p", [
        _vm._v("版权所有 © 濮阳市广播电视台\n            "),
        _c(
          "a",
          {
            attrs: {
              href: "https://beian.miit.gov.cn/#/Integrated/index",
              target: "_black"
            }
          },
          [_vm._v("\n              豫ICP备20018960号-1\n            ")]
        )
      ])
    ])
  }
]
footer_render._withStripped = true
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var footer_footer = (footer_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-3788cc60", footer_esExports)
  }
}
// CONCATENATED MODULE: ./app/web/component/web/news-layout/footer/footer.vue
var footer_disposed = false
function footer_injectStyle (ssrContext) {
  if (footer_disposed) return
  __webpack_require__("lleX")
}
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = footer_injectStyle
/* scopeId */
var footer___vue_scopeId__ = "data-v-3788cc60"
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  footer_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)
footer_Component.options.__file = "app/web/component/web/news-layout/footer/footer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3788cc60", footer_Component.options)
  } else {
    hotAPI.reload("data-v-3788cc60", footer_Component.options)
  }
  module.hot.dispose(function (data) {
    footer_disposed = true
  })
})()}

/* harmony default export */ var news_layout_footer_footer = (footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/web/component/web/news-layout/main.vue





/* harmony default export */ var main = ({
  components: {
    LayoutHeader: news_layout_header_header,
    LayoutFooter: news_layout_footer_footer
  },
  data: function data() {
    return {
      adShows: true,

      signatureObj: {},

      themeConfig: {},
      isIndex: false
    };
  },

  computed: {},
  props: {
    showid: {
      default: 0
    },
    clientId: {},
    ads: {},
    channels: {
      default: []
    },
    apiOrigin: {
      default: ''
    }
  },
  created: function created() {
    var _time = new Date().getTime();
    if (_time > 1639324800000 && _time < 1639411200000) {
      document.getElementsByTagName('html')[0].style['-webkit-filter'] = 'grayscale(100%)';
    }

    this.signatureObj = window.getSignature();
    console.log('this.signatureObj', this.signatureObj, this.apiOrigin);

    this.initWebSetting();
  },

  methods: {
    initWebSetting: function initWebSetting() {
      var _this = this;

      var params = '';
      axios_default.a.get(this.apiOrigin + '/v4/web-theme-config?timestamp=' + this.signatureObj.timestamp + '&nonce=' + this.signatureObj.nonce + '&signature=' + this.signatureObj.signature).then(function (data) {
        console.log('回去网站配置', data);
        if (parseInt(data.data.data.web_theme_style) === 1) {
          _this.themeConfig = data.data.data;
          if (parseInt(data.data.data.web_theme_filter) === 2) {
            _this.isIndex = true;
          }
        }
      });
    },
    topImgClick: function topImgClick() {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f71788","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-layout/main.vue
var main_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "subject",
      class: [_vm.isIndex ? "is-index" : ""],
      style: {
        backgroundColor:
          _vm.themeConfig && _vm.themeConfig.web_theme_background_color
            ? _vm.themeConfig.web_theme_background_color
            : "none"
      }
    },
    [
      _vm.themeConfig && _vm.themeConfig.web_theme_top_img
        ? _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _c("img", {
              staticClass: "theme-top-img",
              attrs: { src: _vm.themeConfig.web_theme_top_img, alt: "" },
              on: { click: _vm.topImgClick }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clientId == 320684
        ? _c("div", {
            staticClass: "jdqz",
            staticStyle: {
              background:
                "url('/public/w/img/410600/znq.png') no-repeat top center",
              width: "100%",
              height: "576px !important"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { position: "relative" } },
        [
          _c("LayoutHeader", {
            attrs: {
              channels: _vm.channels,
              ads: _vm.ads,
              showid: _vm.showid,
              clientId: _vm.clientId,
              apiOrigin: _vm.apiOrigin
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main clear  contents pt30" },
            [_vm._t("main")],
            2
          ),
          _vm._v(" "),
          _vm.clientId == 320598
            ? _c("div", { staticClass: "aside_img_lf" })
            : _vm._e(),
          _vm._v(" "),
          _vm.clientId == 320598
            ? _c("div", { staticClass: "aside_img_rh" })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("LayoutFooter", { attrs: { clientId: _vm.clientId } }, [
        _c(
          "div",
          { attrs: { slot: "bottom" }, slot: "bottom" },
          [_vm._t("bottom")],
          2
        )
      ])
    ],
    1
  )
}
var main_staticRenderFns = []
main_render._withStripped = true
var main_esExports = { render: main_render, staticRenderFns: main_staticRenderFns }
/* harmony default export */ var news_layout_main = (main_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-25f71788", main_esExports)
  }
}
// CONCATENATED MODULE: ./app/web/component/web/news-layout/main.vue
var main_disposed = false
function main_injectStyle (ssrContext) {
  if (main_disposed) return
  __webpack_require__("5nQB")
}
var main_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var main___vue_template_functional__ = false
/* styles */
var main___vue_styles__ = main_injectStyle
/* scopeId */
var main___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var main___vue_module_identifier__ = null
var main_Component = main_normalizeComponent(
  main,
  news_layout_main,
  main___vue_template_functional__,
  main___vue_styles__,
  main___vue_scopeId__,
  main___vue_module_identifier__
)
main_Component.options.__file = "app/web/component/web/news-layout/main.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25f71788", main_Component.options)
  } else {
    hotAPI.reload("data-v-25f71788", main_Component.options)
  }
  module.hot.dispose(function (data) {
    main_disposed = true
  })
})()}

/* harmony default export */ var web_news_layout_main = (main_Component.exports);

// CONCATENATED MODULE: ./app/web/component/web/news-layout/index.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var content = '<div id="app" :class="cityClass"><MainLayout :ads="ads" :clientId="clientId" :showid="showid" :apiOrigin="apiOrigin" :channels="channels"><div slot="bottom"><slot name="bottom"></slot></div><div slot="main"><slot></slot></div></MainLayout></div>';

var template = '<!DOCTYPE html>\n<html lang="en">\n<head>\n  <title>{{vTitle}}</title>\n  <meta name="keywords" :content="vKeywords">\n  <meta name="description" :content="vDescription">\n  <meta http-equiv="content-type" content="text/html;charset=utf-8">\n  <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />\n</head>\n<body  :style="baseClass">\n  <div  id="app" >' + content + '</div>\n</body>\n</html>';

/* harmony default export */ var news_layout = __webpack_exports__["a"] = ({
  name: 'Layout',
  props: {
    setTitle: {
      default: false
    },
    apiOrigin: {
      default: ''
    },
    description: {},
    showid: {
      default: -2
    },
    clientId: {},
    ads: {
      default: function _default() {
        return {
          banner1: {},
          banner2: {},
          banner3: {},
          duration: 0,
          slide: {},
          slideBars: []
        };
      }
    },
    keywords: {},
    channels: {
      default: []
    }
  },
  components: {
    MainLayout: web_news_layout_main
  },
  data: function data() {
    return {
      title: { 320598: { name: '吴江新闻网' } },
      baseStyle: {
        320598: {}
      }
    };
  },
  mounted: function mounted() {
    console.log('apiOrigin', this.apiOrigin);
  },

  computed: {
    vTitle: function vTitle() {
      if (!this.setTitle) {
        return this.title[this.clientId].name;
      } else {
        return this.setTitle;
      }
    },
    vKeywords: function vKeywords() {
      return this.$root.keywords || this.keywords || '';
    },
    vDescription: function vDescription() {
      return this.$root.description || this.description || 'egg-vue-webpack server side render';
    },
    cityClass: function cityClass() {
      var cityCls = this.$root.cityClass;
      return cityCls;
    },
    baseClass: function baseClass() {
      return this.baseStyle[this.clientId];
    }
  },
  template: (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' ? content : template
});

/***/ }),

/***/ "cA+x":
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__("Jvcu")

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addDays(dirtyDate, -amount)
}

module.exports = subDays


/***/ }),

/***/ "cFQA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./app/web/asset/js/utils/friendlyTime.js + 1 modules
var friendlyTime = __webpack_require__("p4GF");

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.common.js
var vue_common = __webpack_require__("I3G/");
var vue_common_default = /*#__PURE__*/__webpack_require__.n(vue_common);

// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.js
var vue_lazyload = __webpack_require__("cTzj");
var vue_lazyload_default = /*#__PURE__*/__webpack_require__.n(vue_lazyload);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/web/component/web/news-list/public-list.vue






vue_common_default.a.use(vue_lazyload_default.a);

/* harmony default export */ var public_list = ({
    props: ['title', 'list', 'clientId'],
    computed: {
        lazyLoading: function lazyLoading() {
            if (this.clientId) {
                return '/public/w/img/' + this.clientId + '/loading_news.png';
            } else {
                return '/public/w/default/loading_news.png';
            }
        }
    },
    data: function data() {
        return {
            friendlyTime: friendlyTime["a" /* default */],
            loadingPic: {
                410600: {
                    logo: '/public/w/img/320598/loading_news.png'
                },
                320598: {
                    logo: '/public/w/img/410600/loading_news.png'
                }
            }
        };
    },

    methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66491712","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-list/public-list.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list" },
    _vm._l(_vm.list, function(item, index) {
      return _c("div", [
        item.news_type != 4
          ? _c("div", { staticClass: "media media-1" }, [
              _c("div", { staticClass: "media-left" }, [
                _c(
                  "i",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.view_tag,
                        expression: "item.view_tag"
                      }
                    ]
                  },
                  [_vm._v(_vm._s(item.view_tag))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.open_type == 1,
                        expression: "item.open_type==1"
                      }
                    ],
                    attrs: { href: item.third_url, target: "_blank" }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: {
                            loading: _vm.lazyLoading,
                            error: _vm.lazyLoading,
                            src: item.img_url[0]
                          },
                          expression:
                            "{\n                            loading: lazyLoading,\n                            error: lazyLoading,\n                            src: item.img_url[0]\n                          }"
                        }
                      ],
                      attrs: { "data-src": "/public/w/img/wap/loading.png" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.open_type == 0,
                        expression: "item.open_type==0"
                      }
                    ],
                    attrs: { href: "/news/" + item.id, target: "_blank" }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: {
                            loading: _vm.lazyLoading,
                            error: _vm.lazyLoading,
                            src: item.img_url[0]
                          },
                          expression:
                            "{\n                        loading: lazyLoading,\n                        error: lazyLoading,\n                        src: item.img_url[0]\n                      }"
                        }
                      ],
                      attrs: { "data-src": "/public/w/img/wap/loading.png" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "media-body" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.open_type == 1,
                        expression: "item.open_type==1"
                      }
                    ],
                    attrs: { href: item.third_url, target: "_blank" }
                  },
                  [
                    _c("h1", {
                      staticClass: "media-heading textone-1",
                      domProps: { innerHTML: _vm._s(item.title) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.open_type == 0,
                        expression: "item.open_type==0"
                      }
                    ],
                    attrs: { href: "/news/" + item.id, target: "_blank" }
                  },
                  [
                    _c("h1", {
                      staticClass: "media-heading textone-1",
                      domProps: { innerHTML: _vm._s(item.title) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "textTow" }, [
                  _vm._v(_vm._s(item.abstract))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "last" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.source,
                          expression: "item.source"
                        }
                      ]
                    },
                    [_vm._v("来源：" + _vm._s(item.source))]
                  ),
                  _vm._v(" "),
                  item.author && _vm.clientId == 410600
                    ? _c("span", [_vm._v("编辑：" + _vm._s(item.author))])
                    : _vm._e(),
                  _vm._v(" "),
                  item.author && _vm.clientId !== 410600
                    ? _c("span", [_vm._v("作者：" + _vm._s(item.author))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.released_at,
                          expression: "item.released_at"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.friendlyTime(item.released_at, "mohu", 1))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (item.views || item.views == 0) &&
                            !(_vm.clientId == 321300 || _vm.clientId == 320100),
                          expression:
                            "(item.views||item.views==0)&&(!(clientId==321300||clientId==320100))"
                        }
                      ],
                      staticClass: "views"
                    },
                    [_vm._v(_vm._s(item.views) + "人阅读")]
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        item.news_type == 4
          ? _c("div", { staticClass: "media media-2" }, [
              _c("div", { staticClass: "media-left" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "/news/topic/" + item.id, target: "_blank" }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: {
                            loading: _vm.lazyLoading,
                            error: _vm.lazyLoading,
                            src: item.img_url[0]
                          },
                          expression:
                            "{\n                        loading: lazyLoading,\n                        error: lazyLoading,\n                        src: item.img_url[0]\n                      }"
                        }
                      ],
                      staticClass: "media-object",
                      attrs: { "data-src": "/public/w/img/wap/loading.png" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "media-body elip" }, [
                _vm._v(_vm._s(item.title))
              ])
            ])
          : _vm._e()
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var news_list_public_list = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-66491712", esExports)
  }
}
// CONCATENATED MODULE: ./app/web/component/web/news-list/public-list.vue
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  public_list,
  news_list_public_list,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "app/web/component/web/news-list/public-list.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-66491712", Component.options)
  } else {
    hotAPI.reload("data-v-66491712", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var web_news_list_public_list = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cONr":
/***/ (function(module, exports, __webpack_require__) {

var isSameMonth = __webpack_require__("f+sD")

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return isSameMonth(new Date(), dirtyDate)
}

module.exports = isThisMonth


/***/ }),

/***/ "cTzj":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Vue-Lazyload.js v1.1.4
 * (c) 2017 Awe <hilongjw@gmail.com>
 * Released under the MIT License.
 */
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e.VueLazyload=t()}(this,function(){"use strict";function e(e,t){if(e.length){var n=e.indexOf(t);return n>-1?e.splice(n,1):void 0}}function t(e,t){if(!e||!t)return e||{};if(e instanceof Object)for(var n in t)e[n]=t[n];return e}function n(e,t){for(var n=!1,r=0,i=e.length;r<i;r++)if(t(e[r])){n=!0;break}return n}function r(e,t){if("IMG"===e.tagName&&e.getAttribute("data-srcset")){var n=e.getAttribute("data-srcset"),r=[],i=e.parentNode,o=i.offsetWidth*t,s=void 0,a=void 0,u=void 0;n=n.trim().split(","),n.map(function(e){e=e.trim(),s=e.lastIndexOf(" "),-1===s?(a=e,u=999998):(a=e.substr(0,s),u=parseInt(e.substr(s+1,e.length-s-2),10)),r.push([u,a])}),r.sort(function(e,t){if(e[0]<t[0])return-1;if(e[0]>t[0])return 1;if(e[0]===t[0]){if(-1!==t[1].indexOf(".webp",t[1].length-5))return 1;if(-1!==e[1].indexOf(".webp",e[1].length-5))return-1}return 0});for(var l="",d=void 0,c=r.length,h=0;h<c;h++)if(d=r[h],d[0]>=o){l=d[1];break}return l}}function i(e,t){for(var n=void 0,r=0,i=e.length;r<i;r++)if(t(e[r])){n=e[r];break}return n}function o(){if(!h)return!1;var e=!0,t=document;try{var n=t.createElement("object");n.type="image/webp",n.style.visibility="hidden",n.innerHTML="!",t.body.appendChild(n),e=!n.offsetWidth,t.body.removeChild(n)}catch(t){e=!1}return e}function s(e,t){var n=null,r=0;return function(){if(!n){var i=Date.now()-r,o=this,s=arguments,a=function(){r=Date.now(),n=!1,e.apply(o,s)};i>=t?a():n=setTimeout(a,t)}}}function a(e){return null!==e&&"object"===(void 0===e?"undefined":c(e))}function u(e){if(!(e instanceof Object))return[];if(Object.keys)return Object.keys(e);var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(n);return t}function l(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function d(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},h="undefined"!=typeof window,f=h&&"IntersectionObserver"in window,v={event:"event",observer:"observer"},p=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return h&&window.devicePixelRatio||e},g=function(){if(h){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0}});window.addEventListener("test",null,t)}catch(e){}return e}}(),y={on:function(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];g?e.addEventListener(t,n,{capture:r,passive:!0}):e.addEventListener(t,n,r)},off:function(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];e.removeEventListener(t,n,r)}},b=function(e,t,n){var r=new Image;r.src=e.src,r.onload=function(){t({naturalHeight:r.naturalHeight,naturalWidth:r.naturalWidth,src:r.src})},r.onerror=function(e){n(e)}},m=function(e,t){return"undefined"!=typeof getComputedStyle?getComputedStyle(e,null).getPropertyValue(t):e.style[t]},L=function(e){return m(e,"overflow")+m(e,"overflow-y")+m(e,"overflow-x")},w=function(e){if(h){if(!(e instanceof HTMLElement))return window;for(var t=e;t&&t!==document.body&&t!==document.documentElement&&t.parentNode;){if(/(scroll|auto)/.test(L(t)))return t;t=t.parentNode}return window}},_=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),k={},E=function(){function e(t){var n=t.el,r=t.src,i=t.error,o=t.loading,s=t.bindType,a=t.$parent,u=t.options,d=t.elRenderer;l(this,e),this.el=n,this.src=r,this.error=i,this.loading=o,this.bindType=s,this.attempt=0,this.naturalHeight=0,this.naturalWidth=0,this.options=u,this.filter(),this.initState(),this.performanceData={init:Date.now(),loadStart:null,loadEnd:null},this.rect=n.getBoundingClientRect(),this.$parent=a,this.elRenderer=d,this.render("loading",!1)}return _(e,[{key:"initState",value:function(){this.state={error:!1,loaded:!1,rendered:!1}}},{key:"record",value:function(e){this.performanceData[e]=Date.now()}},{key:"update",value:function(e){var t=e.src,n=e.loading,r=e.error,i=this.src;this.src=t,this.loading=n,this.error=r,this.filter(),i!==this.src&&(this.attempt=0,this.initState())}},{key:"getRect",value:function(){this.rect=this.el.getBoundingClientRect()}},{key:"checkInView",value:function(){return this.getRect(),this.rect.top<window.innerHeight*this.options.preLoad&&this.rect.bottom>this.options.preLoadTop&&this.rect.left<window.innerWidth*this.options.preLoad&&this.rect.right>0}},{key:"filter",value:function(){var e=this;u(this.options.filter).map(function(t){e.options.filter[t](e,e.options)})}},{key:"renderLoading",value:function(e){var t=this;b({src:this.loading},function(n){t.render("loading",!1),e()},function(n){e(),t.options.silent||console.warn("VueLazyload log: load failed with loading image("+t.loading+")")})}},{key:"load",value:function(){var e=this;return this.attempt>this.options.attempt-1&&this.state.error?void(this.options.silent||console.log("VueLazyload log: "+this.src+" tried too more than "+this.options.attempt+" times")):this.state.loaded||k[this.src]?this.render("loaded",!0):void this.renderLoading(function(){e.attempt++,e.record("loadStart"),b({src:e.src},function(t){e.naturalHeight=t.naturalHeight,e.naturalWidth=t.naturalWidth,e.state.loaded=!0,e.state.error=!1,e.record("loadEnd"),e.render("loaded",!1),k[e.src]=1},function(t){e.state.error=!0,e.state.loaded=!1,e.render("error",!1)})})}},{key:"render",value:function(e,t){this.elRenderer(this,e,t)}},{key:"performance",value:function(){var e="loading",t=0;return this.state.loaded&&(e="loaded",t=(this.performanceData.loadEnd-this.performanceData.loadStart)/1e3),this.state.error&&(e="error"),{src:this.src,state:e,time:t}}},{key:"destroy",value:function(){this.el=null,this.src=null,this.error=null,this.loading=null,this.bindType=null,this.attempt=0}}]),e}(),T=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),A="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",$=["scroll","wheel","mousewheel","resize","animationend","transitionend","touchmove"],z={rootMargin:"0px",threshold:0},H=function(u){return function(){function l(e){var t=e.preLoad,n=e.error,r=e.throttleWait,i=e.preLoadTop,a=e.dispatchEvent,u=e.loading,c=e.attempt,h=e.silent,f=e.scale,g=e.listenEvents,y=(e.hasbind,e.filter),b=e.adapter,m=e.observer,L=e.observerOptions;d(this,l),this.version="1.1.4",this.mode=v.event,this.ListenerQueue=[],this.TargetIndex=0,this.TargetQueue=[],this.options={silent:h||!0,dispatchEvent:!!a,throttleWait:r||200,preLoad:t||1.3,preLoadTop:i||0,error:n||A,loading:u||A,attempt:c||3,scale:f||p(f),ListenEvents:g||$,hasbind:!1,supportWebp:o(),filter:y||{},adapter:b||{},observer:!!m,observerOptions:L||z},this._initEvent(),this.lazyLoadHandler=s(this._lazyLoadHandler.bind(this),this.options.throttleWait),this.setMode(this.options.observer?v.observer:v.event)}return T(l,[{key:"config",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};t(this.options,e)}},{key:"performance",value:function(){var e=[];return this.ListenerQueue.map(function(t){e.push(t.performance())}),e}},{key:"addLazyBox",value:function(e){this.ListenerQueue.push(e),h&&(this._addListenerTarget(window),this._observer&&this._observer.observe(e.el),e.$el&&e.$el.parentNode&&this._addListenerTarget(e.$el.parentNode))}},{key:"add",value:function(e,t,i){var o=this;if(n(this.ListenerQueue,function(t){return t.el===e}))return this.update(e,t),u.nextTick(this.lazyLoadHandler);var s=this._valueFormatter(t.value),a=s.src,l=s.loading,d=s.error;u.nextTick(function(){a=r(e,o.options.scale)||a,o._observer&&o._observer.observe(e);var n=Object.keys(t.modifiers)[0],s=void 0;n&&(s=i.context.$refs[n],s=s?s.$el||s:document.getElementById(n)),s||(s=w(e));var c=new E({bindType:t.arg,$parent:s,el:e,loading:l,error:d,src:a,elRenderer:o._elRenderer.bind(o),options:o.options});o.ListenerQueue.push(c),h&&(o._addListenerTarget(window),o._addListenerTarget(s)),o.lazyLoadHandler(),u.nextTick(function(){return o.lazyLoadHandler()})})}},{key:"update",value:function(e,t){var n=this,o=this._valueFormatter(t.value),s=o.src,a=o.loading,l=o.error;s=r(e,this.options.scale)||s;var d=i(this.ListenerQueue,function(t){return t.el===e});d&&d.update({src:s,loading:a,error:l}),this._observer&&this._observer.observe(e),this.lazyLoadHandler(),u.nextTick(function(){return n.lazyLoadHandler()})}},{key:"remove",value:function(t){if(t){this._observer&&this._observer.unobserve(t);var n=i(this.ListenerQueue,function(e){return e.el===t});n&&(this._removeListenerTarget(n.$parent),this._removeListenerTarget(window),e(this.ListenerQueue,n)&&n.destroy())}}},{key:"removeComponent",value:function(t){t&&(e(this.ListenerQueue,t),this._observer&&this._observer.unobserve(t.el),t.$parent&&t.$el.parentNode&&this._removeListenerTarget(t.$el.parentNode),this._removeListenerTarget(window))}},{key:"setMode",value:function(e){var t=this;f||e!==v.observer||(e=v.event),this.mode=e,e===v.event?(this._observer&&(this.ListenerQueue.forEach(function(e){t._observer.unobserve(e.el)}),this._observer=null),this.TargetQueue.forEach(function(e){t._initListen(e.el,!0)})):(this.TargetQueue.forEach(function(e){t._initListen(e.el,!1)}),this._initIntersectionObserver())}},{key:"_addListenerTarget",value:function(e){if(e){var t=i(this.TargetQueue,function(t){return t.el===e});return t?t.childrenCount++:(t={el:e,id:++this.TargetIndex,childrenCount:1,listened:!0},this.mode===v.event&&this._initListen(t.el,!0),this.TargetQueue.push(t)),this.TargetIndex}}},{key:"_removeListenerTarget",value:function(e){var t=this;this.TargetQueue.forEach(function(n,r){n.el===e&&(--n.childrenCount||(t._initListen(n.el,!1),t.TargetQueue.splice(r,1),n=null))})}},{key:"_initListen",value:function(e,t){var n=this;this.options.ListenEvents.forEach(function(r){return y[t?"on":"off"](e,r,n.lazyLoadHandler)})}},{key:"_initEvent",value:function(){var t=this;this.Event={listeners:{loading:[],loaded:[],error:[]}},this.$on=function(e,n){t.Event.listeners[e].push(n)},this.$once=function(e,n){function r(){i.$off(e,r),n.apply(i,arguments)}var i=t;t.$on(e,r)},this.$off=function(n,r){if(!r)return void(t.Event.listeners[n]=[]);e(t.Event.listeners[n],r)},this.$emit=function(e,n,r){t.Event.listeners[e].forEach(function(e){return e(n,r)})}}},{key:"_lazyLoadHandler",value:function(){var e=!1;this.ListenerQueue.forEach(function(t){t.state.loaded||(e=t.checkInView())&&t.load()})}},{key:"_initIntersectionObserver",value:function(){var e=this;f&&(this._observer=new IntersectionObserver(this._observerHandler.bind(this),this.options.observerOptions),this.ListenerQueue.length&&this.ListenerQueue.forEach(function(t){e._observer.observe(t.el)}))}},{key:"_observerHandler",value:function(e,t){var n=this;e.forEach(function(e){e.isIntersecting&&n.ListenerQueue.forEach(function(t){if(t.el===e.target){if(t.state.loaded)return n._observer.unobserve(t.el);t.load()}})})}},{key:"_elRenderer",value:function(e,t,n){if(e.el){var r=e.el,i=e.bindType,o=void 0;switch(t){case"loading":o=e.loading;break;case"error":o=e.error;break;default:o=e.src}if(i?r.style[i]="url("+o+")":r.getAttribute("src")!==o&&r.setAttribute("src",o),r.setAttribute("lazy",t),this.$emit(t,e,n),this.options.adapter[t]&&this.options.adapter[t](e,this.options),this.options.dispatchEvent){var s=new CustomEvent(t,{detail:e});r.dispatchEvent(s)}}}},{key:"_valueFormatter",value:function(e){var t=e,n=this.options.loading,r=this.options.error;return a(e)&&(e.src||this.options.silent||console.error("Vue Lazyload warning: miss src with "+e),t=e.src,n=e.loading||this.options.loading,r=e.error||this.options.error),{src:t,loading:n,error:r}}}]),l}()},O=function(e){return{props:{tag:{type:String,default:"div"}},render:function(e){return!1===this.show?e(this.tag):e(this.tag,null,this.$slots.default)},data:function(){return{el:null,state:{loaded:!1},rect:{},show:!1}},mounted:function(){this.el=this.$el,e.addLazyBox(this),e.lazyLoadHandler()},beforeDestroy:function(){e.removeComponent(this)},methods:{getRect:function(){this.rect=this.$el.getBoundingClientRect()},checkInView:function(){return this.getRect(),h&&this.rect.top<window.innerHeight*e.options.preLoad&&this.rect.bottom>0&&this.rect.left<window.innerWidth*e.options.preLoad&&this.rect.right>0},load:function(){this.show=!0,this.state.loaded=!0,this.$emit("show",this)}}}};return{install:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=H(e),i=new r(n),o="2"===e.version.split(".")[0];e.prototype.$Lazyload=i,n.lazyComponent&&e.component("lazy-component",O(i)),o?e.directive("lazy",{bind:i.add.bind(i),update:i.update.bind(i),componentUpdated:i.lazyLoadHandler.bind(i),unbind:i.remove.bind(i)}):e.directive("lazy",{bind:i.lazyLoadHandler.bind(i),update:function(e,n){t(this.vm.$refs,this.vm.$els),i.add(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:e,oldValue:n},{context:this.vm})},unbind:function(){i.remove(this.el)}})}}});


/***/ }),

/***/ "cw9o":
/***/ (function(module, exports, __webpack_require__) {

var addWeeks = __webpack_require__("7EGB")

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks


/***/ }),

/***/ "cwv1":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),

/***/ "danj":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse(dirtyDate)
  var minutes = Number(dirtyMinutes)
  date.setMinutes(minutes)
  return date
}

module.exports = setMinutes


/***/ }),

/***/ "deGw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e/EH":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 3
}

module.exports = isWednesday


/***/ }),

/***/ "eCZG":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),

/***/ "eKpK":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate) {
  var date = parse(dirtyDate)
  var seconds = date.getSeconds()
  return seconds
}

module.exports = getSeconds


/***/ }),

/***/ "f+sD":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

module.exports = isSameMonth


/***/ }),

/***/ "f4ga":
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__("WNGz")

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),

/***/ "fK0I":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() > dateToCompare.getTime()
}

module.exports = isAfter


/***/ }),

/***/ "fUo1":
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__("iRXW")
var addWeeks = __webpack_require__("7EGB")

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate) {
  var thisYear = startOfISOYear(dirtyDate)
  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
  var diff = nextYear.valueOf() - thisYear.valueOf()
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK)
}

module.exports = getISOWeeksInYear


/***/ }),

/***/ "fo7E":
/***/ (function(module, exports, __webpack_require__) {

var addHours = __webpack_require__("w4by")

/**
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addHours(dirtyDate, -amount)
}

module.exports = subHours


/***/ }),

/***/ "gAt4":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var differenceInCalendarDays = __webpack_require__("nizW")
var compareAsc = __webpack_require__("NKE6")

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastDayNotFull)
}

module.exports = differenceInDays


/***/ }),

/***/ "gDPd":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() < dateToCompare.getTime()
}

module.exports = isBefore


/***/ }),

/***/ "gIln":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./app/web/asset/js/utils/friendlyTime.js + 1 modules
var friendlyTime = __webpack_require__("p4GF");

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.common.js
var vue_common = __webpack_require__("I3G/");
var vue_common_default = /*#__PURE__*/__webpack_require__.n(vue_common);

// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.js
var vue_lazyload = __webpack_require__("cTzj");
var vue_lazyload_default = /*#__PURE__*/__webpack_require__.n(vue_lazyload);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/web/component/web/news-aside/index.vue





vue_common_default.a.use(vue_lazyload_default.a, {
    error: '/public/w/img/wap/loading.png',
    loading: '/public/w/img/wap/loading.png'
});
/* harmony default export */ var news_aside = ({
    props: ['title', 'list'],
    data: function data() {
        return {
            friendlyTime: friendlyTime["a" /* default */]
        };
    },

    components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-600714c5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-aside/index.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.list.length != 0,
          expression: "list.length!=0"
        }
      ],
      staticClass: "aside-1"
    },
    [
      _c("dl", [
        _c("div", { staticClass: "title" }, [
          _c("i"),
          _vm._v(_vm._s(_vm.title))
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.list, function(item, index) {
        return _c("dd", [
          _c("i"),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: item.open_type == 0 ? "/news/" + item.id : item.third_url
              }
            },
            [_vm._v(_vm._s(item.title))]
          ),
          _c("span", [_vm._v(_vm._s(_vm.friendlyTime(item.released_at)))])
        ])
      }),
      _vm._v(" "),
      _c("span")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var web_news_aside = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-600714c5", esExports)
  }
}
// CONCATENATED MODULE: ./app/web/component/web/news-aside/index.vue
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  news_aside,
  web_news_aside,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "app/web/component/web/news-aside/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-600714c5", Component.options)
  } else {
    hotAPI.reload("data-v-600714c5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var component_web_news_aside = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gUEJ":
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfTomorrow


/***/ }),

/***/ "hUHO":
/***/ (function(module, exports, __webpack_require__) {

var isSameISOYear = __webpack_require__("4LxA")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Is the given date in the same ISO week-numbering year as the current date?
 *
 * @description
 * Is the given date in the same ISO week-numbering year as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week-numbering year
 *
 * @example
 * // If today is 25 September 2014,
 * // is 30 December 2013 in this ISO week-numbering year?
 * var result = isThisISOYear(new Date(2013, 11, 30))
 * //=> true
 */
function isThisISOYear (dirtyDate) {
  return isSameISOYear(new Date(), dirtyDate)
}

module.exports = isThisISOYear


/***/ }),

/***/ "hico":
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__("zZbG")
var startOfISOWeek = __webpack_require__("3znZ")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year + 1, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  date.setDate(date.getDate() - 1)
  return date
}

module.exports = lastDayOfISOYear


/***/ }),

/***/ "hj5Y":
/***/ (function(module, exports, __webpack_require__) {

var isSameSecond = __webpack_require__("5qwL")

/**
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond (dirtyDate) {
  return isSameSecond(new Date(), dirtyDate)
}

module.exports = isThisSecond


/***/ }),

/***/ "hkaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var api = {
  search: 'news/search',
  news: 'news',
  topicsRelations: 'news/topic/',
  topics: 'news/topics',
  bianmin: 'news/bianmin',
  rewen: 'hot',
  channels: 'news/channels',
  relationnews: 'news/getrelationnews',
  uarUrl: 'news/recom'
};
/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ "jy2q":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var setMonth = __webpack_require__("balU")

/**
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter setted
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter) {
  var date = parse(dirtyDate)
  var quarter = Number(dirtyQuarter)
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
  var diff = quarter - oldQuarter
  return setMonth(date, date.getMonth() + diff * 3)
}

module.exports = setQuarter


/***/ }),

/***/ "kDuD":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var endOfDay = __webpack_require__("MIQa")
var endOfMonth = __webpack_require__("xKy+")

/**
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  return endOfDay(date).getTime() === endOfMonth(date).getTime()
}

module.exports = isLastDayOfMonth


/***/ }),

/***/ "kIFi":
/***/ (function(module, exports, __webpack_require__) {

var addMinutes = __webpack_require__("NSOL")

/**
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the mintues subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMinutes(dirtyDate, -amount)
}

module.exports = subMinutes


/***/ }),

/***/ "kRs6":
/***/ (function(module, exports, __webpack_require__) {

var isSameYear = __webpack_require__("Qxz6")

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return isSameYear(new Date(), dirtyDate)
}

module.exports = isThisYear


/***/ }),

/***/ "kjlQ":
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__("G7No")

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInHours


/***/ }),

/***/ "kkVd":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate) {
  return parse(dirtyDate).getDay() === 1
}

module.exports = isMonday


/***/ }),

/***/ "l85J":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  return month
}

module.exports = getMonth


/***/ }),

/***/ "lQzg":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var quarter = Math.floor(date.getMonth() / 3) + 1
  return quarter
}

module.exports = getQuarter


/***/ }),

/***/ "lleX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mSFb":
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of yesterday.
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYesterday


/***/ }),

/***/ "mXYp":
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__("YRFD")
var parse = __webpack_require__("xA5w")
var differenceInSeconds = __webpack_require__("25hp")
var differenceInMonths = __webpack_require__("GI7G")
var enLocale = __webpack_require__("uyaC")

var MINUTES_IN_DAY = 1440
var MINUTES_IN_ALMOST_TWO_DAYS = 2520
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_TWO_MONTHS = 86400

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWords(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = distanceInWords(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWords(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWords(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = Math.round(seconds / 60) - offset
  var months

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return localize('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return localize('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return localize('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return localize('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return localize('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return localize('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60)
    return localize('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return localize('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('aboutXMonths', months, localizeOptions)
  }

  months = differenceInMonths(dateRight, dateLeft)

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12
    var years = Math.floor(months / 12)

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return localize('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return localize('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return localize('almostXYears', years + 1, localizeOptions)
    }
  }
}

module.exports = distanceInWords


/***/ }),

/***/ "nZeo":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year
}

module.exports = getYear


/***/ }),

/***/ "nfOx":
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__("6Zhv")

/**
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @returns {Date} the new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * 1000)
}

module.exports = addSeconds


/***/ }),

/***/ "nk30":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = lastDayOfWeek


/***/ }),

/***/ "oNnY":
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__("zZbG")
var setISOYear = __webpack_require__("Uu+E")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @returns {Date} the new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
}

module.exports = addISOYears


/***/ }),

/***/ "oke8":
/***/ (function(module, exports, __webpack_require__) {

var addQuarters = __webpack_require__("1rLR")

/**
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @returns {Date} the new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addQuarters(dirtyDate, -amount)
}

module.exports = subQuarters


/***/ }),

/***/ "orNa":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),

/***/ "p4GF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/date-fns/format/index.js
var format = __webpack_require__("Eoz/");
var format_default = /*#__PURE__*/__webpack_require__.n(format);

// CONCATENATED MODULE: ./app/web/asset/js/utils/unix.js

/* harmony default export */ var unix = (function (date) {
  if (!(date && date instanceof Date)) {
    date = new Date();
  }
  return Math.ceil(date.getTime() / 1000);
});
// CONCATENATED MODULE: ./app/web/asset/js/utils/friendlyTime.js



function friendlyTime(sTime) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mohu';

  var nowDate = new Date();

  var cTime = nowDate.getTime();

  var date = nowDate.getDate();
  nowDate.setHours(0);
  nowDate.setMinutes(0);
  nowDate.setMilliseconds(0);

  var todayTime = unix(nowDate);

  var yestodayTime = unix(new Date(nowDate.setDate(date - 1)));

  var tommrrowTime = unix(new Date(nowDate.setDate(date + 1)));

  var weekTime = todayTime - 3600 * 24 * 7;

  var dTime = cTime - sTime;

  if (type == 'mohu') {
    if (dTime < 10) {
      return '刚刚';
    }

    if (dTime >= 10 && dTime < 60) {
      return dTime + ' 秒前';
    } else if (dTime < 3600) {
      return Math.ceil(dTime / 60) + ' 分钟前';
    } else if (sTime < tommrrowTime && sTime > todayTime) {
      var h = Math.ceil(dTime / 3600);

      if (Math.ceil(dTime % 3600 / 60) > 30) {
        h++;
      }

      if (h >= 3) {
        return '今天  ' + format_default()(sTime * 1000, 'HH:mm');
      }
      return h + ' 小时前';
    } else if (sTime < todayTime && sTime > weekTime) {
      if (sTime > yestodayTime && sTime < todayTime) {
        return '昨天 ' + format_default()(sTime * 1000, 'HH:mm');
      } else if (sTime > yestodayTime - 86400 && sTime < yestodayTime) {
        return '前天 ' + format_default()(sTime * 1000, 'HH:mm');
      } else {
        return format_default()(sTime * 1000, 'MM月DD日 HH:mm');
      }
    } else {
      return format_default()(sTime * 1000, 'MM月DD日 HH:mm');
    }
  } else if (type == 'full') {
    return format_default()(sTime * 1000, 'YY-MM-DD , HH:mm:ss');
  } else if (type == 'ymd') {
    return format_default()(sTime * 1000, 'YY-MM-DD , HH:mm:ss');
  } else {
    return format_default()(sTime * 1000, 'YY-MM-DD , HH:mm:ss');
  }
}

/* harmony default export */ var utils_friendlyTime = __webpack_exports__["a"] = (friendlyTime);

/***/ }),

/***/ "pWdO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pe7V":
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__("8KV+")

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
}

module.exports = isThisWeek


/***/ }),

/***/ "qNYo":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var differenceInCalendarISOYears = __webpack_require__("9Jn5")
var compareAsc = __webpack_require__("NKE6")
var subISOYears = __webpack_require__("MKc+")

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
  dateLeft = subISOYears(dateLeft, sign * difference)

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastISOYearNotFull)
}

module.exports = differenceInISOYears


/***/ }),

/***/ "qPxx":
/***/ (function(module, exports, __webpack_require__) {

var startOfHour = __webpack_require__("LLTj")

/**
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
  var dateRightStartOfHour = startOfHour(dirtyDateRight)

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}

module.exports = isSameHour


/***/ }),

/***/ "rBmI":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3
  date.setMonth(month, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfQuarter


/***/ }),

/***/ "rO5X":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var differenceInCalendarYears = __webpack_require__("Bb5e")
var compareAsc = __webpack_require__("NKE6")

/**
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastYearNotFull)
}

module.exports = differenceInYears


/***/ }),

/***/ "sdTe":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse(dirtyLeftDate)
  var dateRight = parse(dirtyRightDate)
  return dateLeft.getTime() === dateRight.getTime()
}

module.exports = isEqual


/***/ }),

/***/ "t6pj":
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__("YRFD")
var parse = __webpack_require__("xA5w")
var differenceInSeconds = __webpack_require__("25hp")
var enLocale = __webpack_require__("uyaC")

var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var unit
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = mathPartial(seconds / 60) - offset
  var hours, days, months, years

  if (options.unit) {
    unit = String(options.unit)
  } else {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60)
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR)
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

module.exports = distanceInWordsStrict


/***/ }),

/***/ "t8zS":
/***/ (function(module, exports, __webpack_require__) {

var lastDayOfWeek = __webpack_require__("nk30")

/**
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate) {
  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = lastDayOfISOWeek


/***/ }),

/***/ "uwZN":
/***/ (function(module, exports, __webpack_require__) {

var isSameQuarter = __webpack_require__("7yyf")

/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter (dirtyDate) {
  return isSameQuarter(new Date(), dirtyDate)
}

module.exports = isThisQuarter


/***/ }),

/***/ "vBvW":
/***/ (function(module, exports, __webpack_require__) {

var distanceInWords = __webpack_require__("mXYp")

/**
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param {Date|String|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = distanceInWordsToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = distanceInWordsToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = distanceInWordsToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWordsToNow (dirtyDate, dirtyOptions) {
  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
}

module.exports = distanceInWordsToNow


/***/ }),

/***/ "ve2D":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 2
}

module.exports = isTuesday


/***/ }),

/***/ "w4by":
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__("6Zhv")

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
}

module.exports = addHours


/***/ }),

/***/ "wAFH":
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__("6Zhv")

/**
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, -amount)
}

module.exports = subMilliseconds


/***/ }),

/***/ "wPo5":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours setted
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours) {
  var date = parse(dirtyDate)
  var hours = Number(dirtyHours)
  date.setHours(hours)
  return date
}

module.exports = setHours


/***/ }),

/***/ "wajf":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")
var getISOWeek = __webpack_require__("D6ie")

/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek) {
  var date = parse(dirtyDate)
  var isoWeek = Number(dirtyISOWeek)
  var diff = getISOWeek(date) - isoWeek
  date.setDate(date.getDate() - diff * 7)
  return date
}

module.exports = setISOWeek


/***/ }),

/***/ "wiYS":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate, index) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = index
      minDistance = distance
    }
  })

  return result
}

module.exports = closestIndexTo


/***/ }),

/***/ "wuJz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  addDays: __webpack_require__("Jvcu"),
  addHours: __webpack_require__("w4by"),
  addISOYears: __webpack_require__("oNnY"),
  addMilliseconds: __webpack_require__("6Zhv"),
  addMinutes: __webpack_require__("NSOL"),
  addMonths: __webpack_require__("3EIC"),
  addQuarters: __webpack_require__("1rLR"),
  addSeconds: __webpack_require__("nfOx"),
  addWeeks: __webpack_require__("7EGB"),
  addYears: __webpack_require__("4Z4o"),
  areRangesOverlapping: __webpack_require__("2lB6"),
  closestIndexTo: __webpack_require__("wiYS"),
  closestTo: __webpack_require__("Tv4R"),
  compareAsc: __webpack_require__("NKE6"),
  compareDesc: __webpack_require__("YRFD"),
  differenceInCalendarDays: __webpack_require__("nizW"),
  differenceInCalendarISOWeeks: __webpack_require__("0aH9"),
  differenceInCalendarISOYears: __webpack_require__("9Jn5"),
  differenceInCalendarMonths: __webpack_require__("orNa"),
  differenceInCalendarQuarters: __webpack_require__("Jtuq"),
  differenceInCalendarWeeks: __webpack_require__("Q2rx"),
  differenceInCalendarYears: __webpack_require__("Bb5e"),
  differenceInDays: __webpack_require__("gAt4"),
  differenceInHours: __webpack_require__("kjlQ"),
  differenceInISOYears: __webpack_require__("qNYo"),
  differenceInMilliseconds: __webpack_require__("G7No"),
  differenceInMinutes: __webpack_require__("3nPg"),
  differenceInMonths: __webpack_require__("GI7G"),
  differenceInQuarters: __webpack_require__("XFzU"),
  differenceInSeconds: __webpack_require__("25hp"),
  differenceInWeeks: __webpack_require__("6SO/"),
  differenceInYears: __webpack_require__("rO5X"),
  distanceInWords: __webpack_require__("mXYp"),
  distanceInWordsStrict: __webpack_require__("t6pj"),
  distanceInWordsToNow: __webpack_require__("vBvW"),
  eachDay: __webpack_require__("M9Ev"),
  endOfDay: __webpack_require__("MIQa"),
  endOfHour: __webpack_require__("bbdo"),
  endOfISOWeek: __webpack_require__("SZZR"),
  endOfISOYear: __webpack_require__("K7ZZ"),
  endOfMinute: __webpack_require__("LU20"),
  endOfMonth: __webpack_require__("xKy+"),
  endOfQuarter: __webpack_require__("zQFw"),
  endOfSecond: __webpack_require__("+sSA"),
  endOfToday: __webpack_require__("0LAu"),
  endOfTomorrow: __webpack_require__("HXCM"),
  endOfWeek: __webpack_require__("I7cV"),
  endOfYear: __webpack_require__("Epw6"),
  endOfYesterday: __webpack_require__("0YGC"),
  format: __webpack_require__("Eoz/"),
  getDate: __webpack_require__("3g9B"),
  getDay: __webpack_require__("Mbb9"),
  getDayOfYear: __webpack_require__("ymQ7"),
  getDaysInMonth: __webpack_require__("Mdww"),
  getDaysInYear: __webpack_require__("Javx"),
  getHours: __webpack_require__("8Gpr"),
  getISODay: __webpack_require__("AZvW"),
  getISOWeek: __webpack_require__("D6ie"),
  getISOWeeksInYear: __webpack_require__("fUo1"),
  getISOYear: __webpack_require__("zZbG"),
  getMilliseconds: __webpack_require__("024F"),
  getMinutes: __webpack_require__("JNsx"),
  getMonth: __webpack_require__("l85J"),
  getOverlappingDaysInRanges: __webpack_require__("8QR2"),
  getQuarter: __webpack_require__("lQzg"),
  getSeconds: __webpack_require__("eKpK"),
  getTime: __webpack_require__("cwv1"),
  getYear: __webpack_require__("nZeo"),
  isAfter: __webpack_require__("fK0I"),
  isBefore: __webpack_require__("gDPd"),
  isDate: __webpack_require__("607n"),
  isEqual: __webpack_require__("sdTe"),
  isFirstDayOfMonth: __webpack_require__("6udH"),
  isFriday: __webpack_require__("YPf8"),
  isFuture: __webpack_require__("6CZb"),
  isLastDayOfMonth: __webpack_require__("kDuD"),
  isLeapYear: __webpack_require__("b7g8"),
  isMonday: __webpack_require__("kkVd"),
  isPast: __webpack_require__("eCZG"),
  isSameDay: __webpack_require__("f4ga"),
  isSameHour: __webpack_require__("qPxx"),
  isSameISOWeek: __webpack_require__("Be26"),
  isSameISOYear: __webpack_require__("4LxA"),
  isSameMinute: __webpack_require__("Moxe"),
  isSameMonth: __webpack_require__("f+sD"),
  isSameQuarter: __webpack_require__("7yyf"),
  isSameSecond: __webpack_require__("5qwL"),
  isSameWeek: __webpack_require__("8KV+"),
  isSameYear: __webpack_require__("Qxz6"),
  isSaturday: __webpack_require__("6axH"),
  isSunday: __webpack_require__("ZUMa"),
  isThisHour: __webpack_require__("z3wv"),
  isThisISOWeek: __webpack_require__("A2zO"),
  isThisISOYear: __webpack_require__("hUHO"),
  isThisMinute: __webpack_require__("Qbo9"),
  isThisMonth: __webpack_require__("cONr"),
  isThisQuarter: __webpack_require__("uwZN"),
  isThisSecond: __webpack_require__("hj5Y"),
  isThisWeek: __webpack_require__("pe7V"),
  isThisYear: __webpack_require__("kRs6"),
  isThursday: __webpack_require__("yu3m"),
  isToday: __webpack_require__("GvNH"),
  isTomorrow: __webpack_require__("0oN5"),
  isTuesday: __webpack_require__("ve2D"),
  isValid: __webpack_require__("dH3X"),
  isWednesday: __webpack_require__("e/EH"),
  isWeekend: __webpack_require__("4OFc"),
  isWithinRange: __webpack_require__("4zIR"),
  isYesterday: __webpack_require__("1gtq"),
  lastDayOfISOWeek: __webpack_require__("t8zS"),
  lastDayOfISOYear: __webpack_require__("hico"),
  lastDayOfMonth: __webpack_require__("Akl5"),
  lastDayOfQuarter: __webpack_require__("T/Ln"),
  lastDayOfWeek: __webpack_require__("nk30"),
  lastDayOfYear: __webpack_require__("xLg3"),
  max: __webpack_require__("11Bn"),
  min: __webpack_require__("aHtT"),
  parse: __webpack_require__("xA5w"),
  setDate: __webpack_require__("/dIK"),
  setDay: __webpack_require__("SHOI"),
  setDayOfYear: __webpack_require__("CVNg"),
  setHours: __webpack_require__("wPo5"),
  setISODay: __webpack_require__("YPjl"),
  setISOWeek: __webpack_require__("wajf"),
  setISOYear: __webpack_require__("Uu+E"),
  setMilliseconds: __webpack_require__("+/J2"),
  setMinutes: __webpack_require__("danj"),
  setMonth: __webpack_require__("balU"),
  setQuarter: __webpack_require__("jy2q"),
  setSeconds: __webpack_require__("ToRI"),
  setYear: __webpack_require__("a7Cs"),
  startOfDay: __webpack_require__("WNGz"),
  startOfHour: __webpack_require__("LLTj"),
  startOfISOWeek: __webpack_require__("3znZ"),
  startOfISOYear: __webpack_require__("iRXW"),
  startOfMinute: __webpack_require__("M5Oo"),
  startOfMonth: __webpack_require__("7Xwz"),
  startOfQuarter: __webpack_require__("rBmI"),
  startOfSecond: __webpack_require__("VaeB"),
  startOfToday: __webpack_require__("1udo"),
  startOfTomorrow: __webpack_require__("gUEJ"),
  startOfWeek: __webpack_require__("u/4p"),
  startOfYear: __webpack_require__("JURy"),
  startOfYesterday: __webpack_require__("mSFb"),
  subDays: __webpack_require__("cA+x"),
  subHours: __webpack_require__("fo7E"),
  subISOYears: __webpack_require__("MKc+"),
  subMilliseconds: __webpack_require__("wAFH"),
  subMinutes: __webpack_require__("kIFi"),
  subMonths: __webpack_require__("7Swd"),
  subQuarters: __webpack_require__("oke8"),
  subSeconds: __webpack_require__("9r5b"),
  subWeeks: __webpack_require__("cw9o"),
  subYears: __webpack_require__("0UyA")
}


/***/ }),

/***/ "xKy+":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfMonth


/***/ }),

/***/ "xLg3":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfYear


/***/ }),

/***/ "yu3m":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate) {
  return parse(dirtyDate).getDay() === 4
}

module.exports = isThursday


/***/ }),

/***/ "z3wv":
/***/ (function(module, exports, __webpack_require__) {

var isSameHour = __webpack_require__("qPxx")

/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour (dirtyDate) {
  return isSameHour(new Date(), dirtyDate)
}

module.exports = isThisHour


/***/ }),

/***/ "zQFw":
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__("xA5w")

/**
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfQuarter


/***/ })

},["GKSN"]);


// WEBPACK FOOTER //
// js/news-pc/index.d171f4de.js